import {
    Box,
    Grid,
    Typography,
    IconButton,
    Stack,
    Divider,
    Dialog,
    Snackbar,
    debounce,
    SelectChangeEvent,
    Button,
    FormControl,
    Tooltip,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add'; // Import the Add icon
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WidgetCardContainer from 'components/Widgets/WidgetCardContainer';
import CustomDropdown from 'components/Dropdown';
import { useEffect, useMemo, useState, ChangeEvent, Fragment, SetStateAction, Dispatch } from 'react';
import useStyles from './data-pipeline-styles';
import { getTeradataJobData, getMDTJobData, getDDHJobData, searchMDTJobNameList, searchDDHJobNameList, getSAPBWJobData, searchSAPBWJobNameList, getWindowsJobData, searchWindowsJobNameList, searchSilverTableName, searchDataAsset, searchADFNameList, getAddedSchedules, getAllDependentJobs, getSearchScheduleJobNameList, getTeradataJobNameList, linkAddScheduleToProject, getFolderNameList, getADFNameList, searchSqlAgentJobNameList, getSqlAgentJobData, getADBWorkspaceNameList, searchADBJobNameList, getADBJobData, searchADBGoldTableNameList, searchIicsJobNameList, getIicsJobData
 } from 'service/service';
import CustomAutocomplete from 'components/Inputs/CustomAutocomplete';
import { CustomizedDataGrid } from 'components/customized_data_grid';
import { DataPipelineModal } from './modal-component';
import LoaderComponent from 'components/Loader';
import DialogModal from 'components/Modal/DialogModal';
import { JobBulkUpload } from './BulkUpload';
import { checkRole } from 'utils/roleUtils';
import eventEmitter from 'SnackBarEventEmitter';
import { Column } from 'react-data-grid';
import TableCheckbox from 'components/Table/TableCheckbox';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { dependInfoTransformData } from 'utils/common-util';
import RowTypography from 'components/Table/RowTypography';
import { CellExpanderFormatter } from 'components/cell_expander_formatter';
import TeradataIcon from '../../assets/icon-teradata.svg';
import DDHIcon from '../../assets/icon-ddh.svg';
import PowerBiIcon from '../../assets/PowerBI.svg';
import { ReactComponent as PlusSymbolIcon } from '../../assets/plus-blue.svg';
import { ReactComponent as BulkUploadIcon } from '../../assets/bulk-upload-dp.svg';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as SuccessTicketIcon } from '../../assets/icon-vector.svg';
import { ReactComponent as DeleteIcon } from '../../assets/PepWise2.0/delete-img-new.svg';  
import { useTheme } from "@mui/material/styles";
import { getDefaultColumnNamesTabs, getFilterDropdownConfig, getPlatformLabels } from 'utils/platformLabelUtil';
import { autocompleteTextFieldProps } from 'utils/dataGridSharedStyles';
import { FOLDER_NAME_TO_ALIAS, PLATFORM_ID_TO_NAME } from './constant';
import { RESTRICTED_ROLE_NAMES } from 'utils/common-util';
import ConfigurePipeline from './configure-parameter';
import info from '../../assets/info-icon.svg';
import { ReactComponent as EditPencilIcon } from '../../assets/material-symbols_edit-rounded_white.svg';
import { convertDayTime, convertTimeToNumber, getCommonCustomTextFieldProps, getInputCustomCommonSx, normalizeFilter, parseFilter, transformFilterOptions, getStatusLabel, getSchedulerDisplayName, getSchedulerLabel, getCyclicLabel, formatScheduleInfo } from './DataPipelineHelper';

type ScheduleFetcher = (
  reqBody: any,
  pageNumber: any,
  pageSize: any,
  filterData?: any
) => Promise<any>;

const platformIcons: any = {
  1: TeradataIcon,
  2: TeradataIcon,
  3: DDHIcon,
  4: PowerBiIcon,
};

function getPlatformIcon(row: any) {
  const icon = platformIcons[row.platformId];
  if (!icon) return null;
  return <img src={icon} alt="platform icon" style={{ width: '18px', verticalAlign: 'middle' }} />;
}

const getPlatformName = (row: any) =>
  FOLDER_NAME_TO_ALIAS[row.folderName] ??
  PLATFORM_ID_TO_NAME[row.platformId] ??
  '';

type PipelineOption = { jobId: string | number; jobName: string; triggerName: string; pipeline_param: Object; };

interface AddedScheduleJobsData {
    [key: string]: any;
    Job_Name: string;
    folderName: string;
    subFolderName: string;
    folderNames: string;
    subFolderNames: string;
    adfName: string;
    dataAssetName: string;
    silverTableName: string;
    triggerName: string;
    jobId: number;
    jobName: string;
    Platform_Id: number;
    startTime: string;
    normalCompletionTime: number;
    scheduler: string;
    dependentData: any;
    dependInfo: any;
    isParent: boolean;
    hasDependent: boolean;
    isExpanded: boolean;
    children: AddedScheduleJobsData[];
    className: string;
    eleLevel: string;
    isChildren?: boolean;
    Dep_Job_Name?: string;
    Project_Schedule_ID: number;
    Primary_Project_Schedule_Id: number;
    Days: number;
    Start_Time: number;
    Normal_Completion_Time: number;
    Scheduler_Name: string;
    schedulerName: string;
    slaDate: any;
    slaTime: number;
    platformId: number;
    scheduleInfo: string;
    priCyclic: string;
    priJobStatus: string;
    depJobStatus: string;
    jobCondition: string;
    goldTableName: string;
    application: string;
    marketUnitName: string;
}

interface ScheduleColumnOptions {
  toggleSubRow: (name: string) => void;
  platformName: string;
  labels: any;
  isAllowed: boolean;
  setDefaultPipelineId: (id: string | number) => void;
  setDefaultTriggerName: (name: string) => void;
  setConfigureOpen: (open: boolean) => void;
  handleTableAction: (row: any, action: string) => void;
}

const getAdbWorkspaceColumn = () => ([
    {
        key: 'workspaceName',
        name: 'Workspace Name',
        formatter(props: any) {
            const workspaceName = props.row.workspaceName?.trim() || '--';
            return (
                <RowTypography textTransform="capitalize" title={workspaceName}>{workspaceName}</RowTypography>
            );
        },
        minWidth: 200,
        maxWidth: 500
    },
]);

const getAdbGoldColumn = () => ([
    {
        key: 'goldTableName',
        name: 'Gold Table Name',
        formatter(props: any) {
            const goldTbleName = props.row.goldTableName ? props.row.goldTableName : '--';
            return <RowTypography textTransform="capitalize" title={goldTbleName}>{goldTbleName}</RowTypography>;
        },
        minWidth: 200,
        maxWidth: 550
    }
]);

const getAdfColumns = () => ([
    {
        key: 'dataAssetName',
        name: 'Data Asset Name',
        formatter(props: any) {
            return <RowTypography>{props.row.dataAssetName ? props.row.dataAssetName : '--'}</RowTypography>;
        },
        minWidth: 200,
        maxWidth: 550
    },
    {
        key: 'silverTableName',
        name: 'Silver Table Name',
        formatter(props: any) {
            return <RowTypography>{props.row.silverTableName ? props.row.silverTableName : '--'}</RowTypography>;
        },
        minWidth: 200,
        maxWidth: 550
    }
]);

const getFolderNameColumn = (capitalize: boolean = false, maxWidth: number = 500) => ([
    {
        key: 'folderNames',
        name: 'Folder Name',
        formatter(props: any) {
            return (
                <RowTypography textTransform={capitalize ? 'capitalize' : undefined} title={props.row.folderNames ? props.row.folderNames : '--'}>
                    {props.row.folderNames ? props.row.folderNames : '--'}</RowTypography>
            );
        },
        minWidth: 200,
        maxWidth
    }
]);

const getSubFolderNameColumn = (capitalize: boolean = false, maxWidth: number = 500) => ([
    {
        key: 'subFolderNames',
        name: 'Subfolder Name',
        formatter(props: any) {
            return (
                <RowTypography textTransform={capitalize ? 'capitalize' : undefined} title={props.row.subFolderNames ? props.row.subFolderNames : '--'}>
                    {props.row.subFolderNames ? props.row.subFolderNames : '--'}</RowTypography>
            );
        },
        minWidth: 200,
        maxWidth
    }
]);

function getAddedScheduleColumns({
    toggleSubRow,
    platformName,
    labels,
    isAllowed,
    setDefaultPipelineId,
    setDefaultTriggerName,
    setConfigureOpen,
    handleTableAction
}: ScheduleColumnOptions): Array<Column<AddedScheduleJobsData>> {
    return [
        {
            key: 'platformId',
            name: 'Platform',
            formatter(props) {
                return (
                    <RowTypography>
                        {getPlatformIcon(props.row)}{' '}
                        {getPlatformName(props.row)}
                    </RowTypography>
                );
            },
            minWidth: 150
        },
        ...(platformName === 'ADF' ? [
            {
                key: 'adfName',
                name: 'ADF Name',
                formatter(props: any) {
                    const adfName = props.row.adfName?.trim() || '--';
                    return (
                        <RowTypography textTransform="capitalize" title={adfName}>{adfName}</RowTypography>
                    );
                },
                minWidth: 200,
                maxWidth: 500
            }
        ] : []),
        ...(platformName === 'ADB' ? getAdbWorkspaceColumn() : []),
        {
            key: 'jobName',
            name: labels.name,
            formatter({ row, isCellSelected }) {
                const hasChildren = row.isParent && row.hasDependent;
                return (
                    <div className={[row.className, row.eleLevel, row.isChildren ? 'child-view' : 'parent-view', hasChildren ? 'has-children' : 'single'].join(' ')}>
                        {hasChildren && (
                            <CellExpanderFormatter
                                isCellSelected={isCellSelected}
                                expanded={row.isExpanded === true}
                                onCellExpand={() => {
                                    toggleSubRow(String(row.jobName));
                                }}
                            />
                        )}
                        {'   '}
                        <Link to="" state={row}>
                            <RowTypography title={row.jobName}>{row.jobName}</RowTypography>
                        </Link>{' '}
                    </div>
                );
            },
            minWidth: 300
        },
        ...(platformName === 'ADB' ? getAdbGoldColumn() : []),
        ...(['All', 'Teradata', 'BODS'].includes(platformName) ? getFolderNameColumn(true) : []),
        ...(['All', 'Teradata', 'BODS'].includes(platformName) ? getSubFolderNameColumn(true) : []),
        ...(platformName === 'ADF' ? [
            {
                key: 'pipeline_param',
                name: 'Parameters',
                formatter(props: any) {
                    const params = props.row.pipeline_param;
                    if (props.row?.pipeline_param !== undefined) {
                        const text = Object.entries(params)
                        .map(([key, value]) => `${key}: ${value}`)
                        .join(', ');
                        
                        return <Box sx={{ position: 'relative' }}><RowTypography style={{ display: 'block', width: '90%' }} title={text}>{ params && Object.keys(params).length ? text : '--' }</RowTypography>
                            {isAllowed && (
                                <IconButton onClick={() => {setDefaultPipelineId(props.row.jobId); setDefaultTriggerName(props.row.triggerName); setConfigureOpen(true);}} title="Click to Edit"
                                sx={{ position: 'absolute', right: 0, top: 0, '& svg path': { fill: '#0c0f25' } }}>
                                    <EditPencilIcon  className="icon-pencil"/>
                                </IconButton>
                            )}
                        </Box>;
                    }
                },
                minWidth: 200,
                maxWidth: 550
            }
        ] : []),
        ...(platformName === 'ADF' ? getAdfColumns() : []),
        ...(platformName === 'ADF' ? [
            {
                key: 'triggerName',
                name: 'Trigger Name',
                formatter(props: any) {
                    return (
                        <RowTypography textTransform="capitalize" title={props.row.triggerName ? props.row.triggerName : '--'}>
                            {props.row.triggerName ? props.row.triggerName : '--'}</RowTypography>
                    );
                },
                minWidth: 200,
                maxWidth: 500

            }
        ] : []),
        ...(['Windows Server'].includes(platformName) ? [
            {
                key: 'taskName',
                name: 'Task Name',
                formatter(props: any) {
                    return (
                        <RowTypography textTransform="capitalize" title={props.row.taskName ? props.row.taskName : '--'}>
                            {props.row.taskName ? props.row.taskName : '--'}
                        </RowTypography>
                    );
                },
                minWidth: 200,
                maxWidth: 500
            }
        ] : []),
        {
            key: 'scheduleInfo',
            name: 'Schedule Info',
            formatter(props) {
                const formattedInfo = formatScheduleInfo(props.row.scheduleInfo);
                return (
                    <RowTypography textTransform="capitalize" title={formattedInfo}>
                        {formattedInfo}</RowTypography>
                );
            },
            minWidth: 200,
            maxWidth: 500
        },

        {
            key: 'schedulerName',
            name: 'Scheduler',
            formatter(props) {
                return (
                    <RowTypography>{getSchedulerDisplayName(props.row)}</RowTypography>
                );
            },
            minWidth: 150
        },
        {
            key: 'priJobStatus',
            name: labels.status,
            formatter(props) {
                const statusText = getStatusLabel(props.row.priJobStatus, props.row.depJobStatus || props.row.jobStatus);
                return (
                    <RowTypography>
                        {statusText}
                    </RowTypography>
                );
            },
            minWidth: 150
        },
        ...(platformName === 'Teradata' ? [
            {
                key: 'jobCondition',
                name: labels.condition,
                formatter(props: any) {
                return (
                    <RowTypography>
                        {props.row.jobCondition ? props.row.jobCondition : '--'}
                    </RowTypography>
                );
            },
            minWidth: 150
            }
        ] : []),
        {
            key: 'priCyclic',
            name: 'Cyclic',
            formatter(props) {
                const cyclicText = getCyclicLabel(props.row.priCyclic);
                return (
                    <RowTypography>
                        {cyclicText}
                    </RowTypography>
                );
            },
            minWidth: 150
        },
        {
            key: 'action',
            name: 'Actions',
            formatter(props: any) {
                return (
                    <Stack direction="row" alignItems="center" height="100%">
                        {isAllowed && (
                            <IconButton onClick={() => handleTableAction(props.row, 'delete')} title="Click to Delete">
                                <DeleteIcon />
                            </IconButton>
                        )}
                    </Stack>
                );
            },
            minWidth: 100
        }
    ];
}

interface Row {
    [key: string]: any;
    id: number;
    selected: boolean;
    jobName: string;
    scheduledDays: string;
    scheduledTimes: string;
    runWindow: string;
    frequency: string;
    SLAODate: string;
    SLATime: string;
    Scheduler: string;
    jobId: string;
    scheduleInfo: string;
    cyclic: string;
    dsName: string;
    dsId: string;
    enabled: boolean;
    workspaceName: string;
    capacityName: string;
    jobStatus: string;
    folderName: string;
    subFolderName: string;
    folderNames: string,
    subFolderNames: string,
    adfName: string;
    triggerName: string;
    dataAssetName: string;
    silverTableName: string;
    goldTableName: string;
    application: string;
    marketUnitName: string;
}

interface ColumnOptions {
  platformName: string;
  labels: any;
  selectedRows: Row[];
  tableDataList: Row[];
  selectedRowsId: any;
  reqRows: Row[];
  setSelectedRows: Dispatch<SetStateAction<Row[]>>;
  setTableDataList: Dispatch<SetStateAction<Row[]>>;
}

function getColumns({
    platformName,
    labels,
    selectedRows,
    tableDataList,
    selectedRowsId,
    reqRows,
    setSelectedRows,
    setTableDataList
}: ColumnOptions): Array<Column<Row>> {
    return [
        {
            key: 'selected',
            name: 'HeaderCheckbox',
            formatter: ({ row }) => (
                <TableCheckbox
                    checked={row.selected}
                    onChange={(e) => {
                        const checked = e.target.checked;
                        const updatedRow = { ...row, selected: checked };
                        const headerCheckboxInput = document.getElementById('HeaderCheckbox') as HTMLInputElement;
                        let tempSelectedRows = [...selectedRows];
                        if (checked) {
                            let result = tempSelectedRows.filter(
                                (obj: any) => (obj.jobId === updatedRow.jobId) && (obj.platformId == 4 ? obj.triggerName == updatedRow.triggerName : true)
                                    && (obj.platformId == 4 ? obj.dataAssetName == updatedRow.dataAssetName : true)
                                    && (obj.platformId == 4 ? obj.silverTableName == updatedRow.silverTableName : true)
                            );
                            if (!result.length) {
                                tempSelectedRows.push(updatedRow);
                                selectedRowsId.push(updatedRow.id);
                            }
                        } else {
                            selectedRowsId.splice(selectedRowsId.indexOf(row.id), 1);
                            let index = tempSelectedRows.findIndex((item: any) => item.id == updatedRow.id)
                            tempSelectedRows.splice(index, 1)
                            if (headerCheckboxInput) {
                                headerCheckboxInput.checked = false;
                            }
                        }

                        if (tempSelectedRows.length == tableDataList.length) {
                            if (headerCheckboxInput) {
                                headerCheckboxInput.checked = true;
                            }
                        }
                        reqRows.length = 0; 
                        reqRows.push(...tempSelectedRows);
                        setSelectedRows(tempSelectedRows);
                        const updatedRowList = (prevRow: Row): Row =>
                            prevRow.id === updatedRow.id ? updatedRow : prevRow;
                        setTableDataList((prevRows) => prevRows.map(updatedRowList));
                    }}
                />
            ),
            width: 40,
            maxWidth: 100
        },
        ...(platformName === 'ADF' ? [
            {
                key: 'adfName',
                name: 'ADF Name',
                formatter(props: any) {
                    return <RowTypography>{props.row.adfName ? props.row.adfName : '--'}</RowTypography>;
                },
                minWidth: 200,
                maxWidth: 550
            }
        ] : []),
        ...(platformName === 'ADB' ? getAdbWorkspaceColumn() : []),
        {
            key: 'jobName',
            name: labels.name,
            formatter(props) {
                return <RowTypography>{props.row.jobName ? props.row.jobName : '--'}</RowTypography>;
            },
            minWidth: 200,
            maxWidth: 550
        },
        ...(platformName === 'ADB' ? getAdbGoldColumn() : []),
        ...(['All', 'Teradata', 'BODS'].includes(platformName) ? getFolderNameColumn(false, 550) : []),
        ...(['All', 'Teradata', 'BODS'].includes(platformName) ? getSubFolderNameColumn(false, 550) : []),
        ...(platformName === 'ADF' ? [
            {
                key: 'triggerName',
                name: 'Trigger Name',
                formatter(props: any) {
                    return <RowTypography>{props.row.triggerName ? props.row.triggerName : '--'}</RowTypography>;
                },
                minWidth: 200,
                maxWidth: 550
            }
        ] : []),
        ...(platformName === 'ADF' ? getAdfColumns() : []),
        ...(platformName === 'Windows Server' ? [
            {
                key: 'taskName',
                name: 'Task Name',
                formatter(props: any) {
                    return <RowTypography>{props.row.taskName ? props.row.taskName : '--'}</RowTypography>;
                },
                minWidth: 200,
                maxWidth: 550
            }
        ] : []),
        {
            key: 'scheduleInfo',
            name: 'Schedule Info',
            formatter(props) {
                return (
                    <RowTypography textTransform="capitalize" title={props.row.scheduleInfo ? props.row.scheduleInfo.replace('At 0 minutes past the hour, ', '') : ''}>{props.row.scheduleInfo ? props.row.scheduleInfo.replace('At 0 minutes past the hour, ', '') : ''}</RowTypography>
                );
            },
            minWidth: 200,
            maxWidth: 550
        },
        {
            key: 'Scheduler',
            name: 'Scheduler',
            formatter(props) {
                const label = getSchedulerLabel(props.row.Scheduler);
                return <RowTypography>{label}</RowTypography>;
            },
            maxWidth: 250
        },
        {
            key: 'jobStatus',
            name: labels.status,
            formatter(props) {
                const statusLabel = getStatusLabel(props.row.jobStatus);
                return <RowTypography>{statusLabel}</RowTypography>;
            },
            maxWidth: 250
        },
        {
            key: 'cyclic',
            name: 'Cyclic',
            formatter(props) {
                const cyclicLabel = getCyclicLabel(props.row.cyclic, props.row.Scheduler);
                return <RowTypography>{cyclicLabel}</RowTypography>;
            },
            maxWidth: 250
        },
    ];
}

interface PowerBiColumnOptions {
  selectedRows: Row[];
  tableDataList: Row[];
  selectedRowsId: any;
  reqRows: Row[];
  setSelectedRows: Dispatch<SetStateAction<Row[]>>;
  setTableDataList: Dispatch<SetStateAction<Row[]>>;
}

function getPowerBiColumns({
    selectedRows,
    tableDataList,
    selectedRowsId,
    reqRows,
    setSelectedRows,
    setTableDataList
}: PowerBiColumnOptions): Array<Column<Row>> {
    return [
        {
            key: 'selected',
            name: 'HeaderCheckbox',
            formatter: ({ row }) => (
                <TableCheckbox
                    checked={row.selected}
                    onChange={(e) => {
                        const checked = e.target.checked;
                        const updatedRow = { ...row, selected: checked };
                        const headerCheckboxInput = document.getElementById('HeaderCheckbox') as HTMLInputElement;
                        let tempSelectedRows = [...reqRows];
                        if (checked) {
                            let result = tempSelectedRows.filter(
                                (obj: any) => obj.dsId === updatedRow.dsId
                            );
                            if (!result.length) {
                                tempSelectedRows.push(updatedRow);
                                selectedRowsId.push(updatedRow.id);
                            }
                        } else {
                            selectedRowsId.splice(selectedRowsId.indexOf(row.id), 1);
                            if (headerCheckboxInput) {
                                headerCheckboxInput.checked = false;
                            }
                        }

                        tempSelectedRows = tempSelectedRows.filter((eachRow: any) => {
                            return selectedRowsId.includes(eachRow.id);
                        });
                        if (tempSelectedRows.length == tableDataList.length) {
                            if (headerCheckboxInput) {
                                headerCheckboxInput.checked = true;
                            }
                        }
                        reqRows = tempSelectedRows;
                        setSelectedRows(tempSelectedRows);
                        const updatedRowList = (prevRow: Row): Row =>
                        prevRow.id === updatedRow.id ? updatedRow : prevRow;
                        setTableDataList((prevRows) => prevRows.map(updatedRowList));
                    }}
                />
            ),
            width: 40,
            maxWidth: 100
        },
        {
            key: 'dsName',
            name: 'Jobs',
            formatter(props) {
                return <RowTypography title={props.row.dsName}>{props.row.dsName ? props.row.dsName : '--'}</RowTypography>;
            },
            minWidth: 200,
            maxWidth: 550
        },
        {
            key: 'capacityName',
            name: 'Capacity',
            formatter(props) {
                return <RowTypography title={props.row.capacityName}>{props.row.capacityName ? props.row.capacityName : '--'}</RowTypography>;
            },
            minWidth: 200,
            maxWidth: 450
        },
        {
            key: 'workspaceName',
            name: 'Workspace',
            formatter(props) {
                return <RowTypography title={props.row.workspaceName}>{props.row.workspaceName ? props.row.workspaceName : '--'}</RowTypography>;
            },
            minWidth: 200,
            maxWidth: 450
        },
        {
            key: 'scheduleInfo',
            name: 'Schedule Info',
            formatter(props) {
                return (
                    <RowTypography textTransform="capitalize"
                        title={props.row.scheduleInfo ? props.row.scheduleInfo : ''}>{props.row.scheduleInfo ? props.row.scheduleInfo : ''}</RowTypography>
                );
            },
            maxWidth: 550
        },
        {
            key: 'enabled',
            name: 'Enabled',
            formatter(props) {
                return <RowTypography>{props.row.enabled ? 'Yes' : 'No'}</RowTypography>;
            },
            maxWidth: 250
        },
    ];
}

interface DialogModalContentProps {
    addProjectLoading?: boolean;
    successMsg: string;
    selectedRows: any[];
    labels: any;
    handleAddMore: () => void;
    handleModalClose: () => void;
}

const DialogModalContent = ({
    addProjectLoading,
    successMsg,
    selectedRows,
    labels,
    handleAddMore,
    handleModalClose
}: DialogModalContentProps) => {

    if (addProjectLoading) {
        return (
            <Box sx={{ p: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(245, 248, 252, 1)' }}>
                <LoaderComponent size={24} />
            </Box>
        );
    }

    const isAlreadyAdded = successMsg === 'Schedules already added!';

    return (
        <Box sx={{ p: 4, textAlign: 'center', backgroundColor: 'rgba(245, 248, 252, 1)' }}>

            {/* Case 1: Already added */}
            {isAlreadyAdded ? (
                <>
                    <Typography sx={{ textAlign: 'center', mb: 2, color: 'rgba(15, 55, 100, 1)', fontSize: '18px', fontWeight: 500 }}>
                        {successMsg}
                    </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                        <Button
                            variant="outlined"
                            onClick={handleModalClose}
                            sx={{
                                color: 'rgba(0, 155, 216, 1)',
                                borderColor: 'rgba(0, 155, 216, 1)',
                                textTransform: 'none',
                                backgroundColor: 'white',
                                '&:hover': {
                                    borderColor: 'rgba(0, 155, 216, 1)',
                                    backgroundColor: 'rgba(0, 155, 216, 0.05)',
                                },
                            }}
                        >
                            Close
                        </Button>
                    </Box>
                </>
            ) : (
                <>
                    {/* Case 2: Schedules added successfully */}
                    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={1.5} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Box sx={{ width: '65px', height: '65px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><SuccessTicketIcon /></Box>
                            </Grid>
                            <Grid item xs={10.5}>
                                <Box sx={{ textAlign: 'left', mt: 1, fontSize: '28px', fontWeight: '500', color: 'rgba(15, 55, 100, 1)' }}>
                                    {selectedRows.length} {selectedRows.length > 1 ? labels.name : labels.name.slice(0, -1)} added successfully in the Project.</Box>
                                <Box sx={{ textAlign: 'left', mt: 1, fontSize: '18px', fontWeight: '400', color: 'rgba(113, 117, 143, 1)' }}>Would you like to add more?</Box>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
                        <Button
                            variant="outlined"
                            onClick={handleAddMore}
                            sx={{
                                color: 'rgba(0, 155, 216, 1)',
                                borderColor: 'rgba(0, 155, 216, 1)',
                                textTransform: 'none',
                                backgroundColor: 'white',
                                '&:hover': {
                                    borderColor: 'rgba(0, 155, 216, 1)',
                                    backgroundColor: 'rgba(0, 155, 216, 0.05)',
                                },
                            }}
                        >
                            SAVE
                        </Button>
                        <Button
                            onClick={handleAddMore}
                            variant="contained"
                            sx={{
                                backgroundColor: 'rgba(0, 155, 216, 1)',
                                color: 'white',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: 'rgba(0, 135, 190, 1)',
                                },
                            }}
                        >
                            ADD MORE
                        </Button>
                    </Box>
                </>
            )}
        </Box>
    );
};

const PLATFORM_LIST = ['ADF', 'Windows Server', 'SAP BW','SQL Server Agent (NewsPage)', 'DDH', 'MDT', 'ADB', 'BODS', 'Teradata', 'IICS'];




export const JobsPipelinesTab = ({ projectData }: any) => {
    const theme = useTheme();
    const colors = theme.palette;
    useEffect(() => {
        document.body.classList.add("v2Background");
    }, []);

    const [controller] = usePepwiseAuthController();
    const { role } = controller;

    const isPwC = checkRole(role, RESTRICTED_ROLE_NAMES);

    const platformList = useMemo(() => {
        if (isPwC) {
            return ['SAP BW'];  // PwC users only see SAP BW
        }
        return PLATFORM_LIST;
    }, [isPwC]);

    interface Filter {
        filterType: string;
        keywords: string | Array<string>;
        fromTime?: any;
        fromTimeValue?: string;
        toTime?: any;
        toTimeValue?: string;
        id?: number;
        operation?: string;
        type?: string;
        subType?: string;
    }

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const prgmid = queryParams.get('programID');
    const prgname = queryParams.get('programName');
    const prjname = queryParams.get('projectName');
    const prjid = queryParams.get('projectId');
    const platformParam = queryParams.get('platform');

    const isEdited = queryParams.get('isEdited');
    let selectedRowsId: any = [];
    

    
    const [platformName, setPlatformName] = useState<string>(() => {
            if (isPwC) {
            return 'SAP BW';  
            }
  			return platformParam ? platformParam : 'ADF';
	});
    const labels = getPlatformLabels(platformName);
    const defaultAddedColumnNamesPlatformBased = getDefaultColumnNamesTabs(platformName);
    let defaultSelectedColumnNamesPlatformBased = [...defaultAddedColumnNamesPlatformBased];
    // Remove "Actions" and "Platform"
    defaultSelectedColumnNamesPlatformBased = defaultSelectedColumnNamesPlatformBased.filter(
        col => col !== 'Actions' && col !== 'Platform' && col !== 'Parameters'
    );
    // Add "HeaderCheckbox" at the start
    defaultSelectedColumnNamesPlatformBased.unshift('HeaderCheckbox');

    const [addedSchedulesList, setAddedSchedulesList] = useState<AddedScheduleJobsData[]>([]);
    const PowerBiColumnNames = ['HeaderCheckbox', 'Jobs', 'Capacity', 'Workspace', 'Schedule Info', 'Enabled'];

    const [selectedRows, setSelectedRows] = useState<Row[]>([]);
    const [tableDataList, setTableDataList] = useState<Row[]>([]);
    const [originalTableDataList, setOriginalTableDataList] = useState<Row[]>([]);

    // configure Pipeline modal state

    const [jobDataList, setJobDataList] = useState<any[]>([]);
    const [jobNameList, setJobNameList] = useState<any[]>([]);
    const [dataAssetNameList, setDataAssetNameList] = useState<any[]>([]);
    const [silverTableNameList, setSilverTableNameList] = useState<any[]>([]);
    const [adfNameList, setAdfNameList] = useState<any[]>([]);
    const [adbWorkspaceNameList, setAdbWorkspaceNameList] = useState<any[]>([]);
    const [folderNameList, setFolderNameList] = useState<any[]>([]);
    const [datasetList, setDatasetList] = useState<any[]>([]);
    const [workspaceList, setWorkspaceList] = useState<any[]>([]);
    const [capacityList, setCapacityList] = useState<any[]>([]);
    const [datasetNameList, setDatasetNameList] = useState<any[]>([]);
    const [workspaceNameList, setWorkspaceNameList] = useState<any[]>([]);
    const [capacityNameList, setCapacityNameList] = useState<any[]>([]);

    const [requestBody, setRequestBody] = useState<any>();
    const [successMsg, setSuccessMsg] = useState<string>('');
    const [successCount, setSuccessCount] = useState<number>(0);

    const [hasSchedulerAdded, setHasSchedulerAdded] = useState<boolean>(true);
    const [hasInstanceAdded, setHasInstanceAdded] = useState<boolean>(true);

    const [tableLoading, setTableLoading] = useState<boolean>();
    const [addProjectLoading, setAddProjectLoading] = useState<boolean>();
    const [openModal, setOpenModal] = useState<any>({ isOpen: false });
    const [deleteModal, setDeleteModal] = useState<any>({ isOpen: false });
    const [toast, setToast] = useState<any>({
        open: false,
        message: ''
    });

    const [configureOpen, setConfigureOpen] = useState(false);
    const [defaultPipelineId, setDefaultPipelineId] = useState<string | number>('');
    const [defaultTriggerName, setDefaultTriggerName] = useState<string | number>('');
    
    const [pipelines, setPipelines] = useState<any[]>([]);


    const [selectedProjectId, setSelectedProjectId] = useState<number | null>(null);
    const [isProjectChanged, setIsProjectChanged] = useState<boolean>(false);

    const [selectedJobName, setSelectedJobName] = useState<boolean>(false);
    const [selectedFolderName, setSelectedFolderName] = useState<boolean>(false);
    const [searchScheduleBtn, setSearchScheduleBtn] = useState<boolean>();
    const [jobSearchKeyword, setJobSearchKeyword] = useState<string>('');
    const [adbWorkspaceSearchKeyword, setAdbWorkspaceSearchKeyword] = useState<string>('');
    const [dataAssetSearchKeyword, setDataAssetSearchKeyword] = useState<string>('');
    const [silverTableSearchKeyword, setSilverTableSearchKeyword] = useState<string>('');
    const [adfSearchKeyword, setAdfSearchKeyword] = useState<string>('');
    const [adfAdded, setAdfAdded] = useState<boolean>(false);
    const [folderSearchKeyword, setFolderSearchKeyword] = useState<string>('');
    const [searchJobNameInputLoading, setSearchJobNameInputLoading] = useState<boolean>();
    const [searchDataAssetInputLoading, setSearchDataAssetInputLoading] = useState<boolean>();
    const [searchSilverTableInputLoading, setSearchSilverTableInputLoading] = useState<boolean>();
    const [searchAdfNameInputLoading, setSearchAdfNameInputLoading] = useState<boolean>();
    const [searchFolderNameInputLoading, setSearchFolderNameInputLoading] = useState<boolean>();
    const [searchDatasetInputLoading, setSearchDatasetInputLoading] = useState<boolean>();
    const [searchWorkspaceInputLoading, setSearchWorkspaceInputLoading] = useState<boolean>();
    const [searchCapacityInputLoading, setSearchCapacityInputLoading] = useState<boolean>();
    const [adbGoldTableNameList, setAdbGoldTableNameList] = useState<any[]>([]);
    const [adbGoldTableSearchKeyword, setAdbGoldTableSearchKeyword] = useState<string>('');
    const [searchGoldTableInputLoading, setSearchGoldTableInputLoading] = useState<boolean>();
    const [selectedGoldTableName, setSelectedGoldTableName] = useState<boolean>(false);

    const [bulkUploadModal, setBulkUploadModal] = useState<boolean>(false);

    const [filterCriteria, setFilterCriteria] = useState<Filter[]>([]);

    const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
    const [page, setPage] = useState('1');
    const [pageSize, setPageSize] = useState('100');

    const [paginationDataSchedule, setPaginationDataSchedule] = useState({ totalElements: 0, totalPages: 0 });
    const [pageSchedule, setPageSchedule] = useState('1');
    const [pageSizeSchedule, setPageSizeSchedule] = useState('100');
    const [scheduleTableLoading, setScheduleTableLoading] = useState<boolean>();
    const [dependentInfoLoading, setDependentInfoLoading] = useState<boolean>();
    let reqRows: Row[] = [];

    const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: 'desc' });
    const [filterInfo, setFilterInfo] = useState([]);
    const [filterData, setFilterData] = useState<Row[]>([]);
    const [filterDataSearch, setFilterDataSearch] = useState<Row[]>([]);
    const [filterInfoSearch, setFilterInfoSearch] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const singularLabelName = useMemo(() => {
        return labels?.name?.replace(/s$/, '');
    }, [labels]);

    const isAllowed = checkRole(role, ['Data Operations Admin', 'PepWise System User']);
    const navigate = useNavigate();

    eventEmitter.on('showSnackbar', (message: string) => {
        setTableLoading(false);
        setScheduleTableLoading(false)
        setSearchDataAssetInputLoading(false)
        setSearchSilverTableInputLoading(false)
        setSearchJobNameInputLoading(false)
        setSearchAdfNameInputLoading(false)
        setSearchFolderNameInputLoading(false)
        setSearchWorkspaceInputLoading(false)
        setAddProjectLoading(false)
    });

    const handleTableAction = (props: any, type: string) => {
        const dta = { ...props, Project_Id: [String(prjid)], programId: prgmid }
        if (type == 'delete') {
            setDeleteModal({
                isOpen: true,
                type: 'Schedule',
                action: 'DELETE',
                from: 'delete',
                data: [dta]
            });
        }
    };

    const getToastData = (data: any) => {
        setToast({
            ...toast,
            message: data.data.message
        });
    };

    const handleClose = () => {
        setToast({
            ...toast,
            open: false
        });
    };

    const handleEditClose = (closeType: any) => {
        setDeleteModal({
            ...openModal,
            isOpen: false,
            closeType: closeType
        });
    };

    const passInfoToParent = (data: any) => {
        getAddedScheduleList();
    };

    function toggleSubRow(name: string) {
        addSchData = addSchData.length ? addSchData : addedSchedulesList;
        const rows = addSchData;
        const rowIndex = rows.findIndex((r: any) => r.jobName == name);
        const row = rows[rowIndex];
        const newRows = [...rows];
        let children: AddedScheduleJobsData[] = [];
        let childRows: AddedScheduleJobsData[] = [];
        if (row.isExpanded === false) {
            const boxRows: any = localStorage.getItem('boxRows');
            const storageRows = boxRows ? JSON.parse(boxRows) : [];
            let hasStrRow = false;
            storageRows.filter((strRow: any) => {
                if (strRow.jobId == row.jobId && strRow.projectId == Number(prjid)) {
                    hasStrRow = true;
                    newRows.splice(Number(rowIndex) + 1, 0, ...strRow.children);
                    newRows[rowIndex] = { ...row, isExpanded: !row.isExpanded, children: strRow.children };
                    const newUpdatedRows = [...newRows];
                    setAddedSchedulesList(newUpdatedRows);
                    addSchData = newUpdatedRows
                }
            });
            if (!hasStrRow) {
                const params = {
                    parentId: row.jobId,
                    platformId: row.platformId,
                    kindName: row.jobName
                }
                setDependentInfoLoading(true)
                const dependentPromise = getAllDependentJobs(params);
                dependentPromise.then((res) => {
                    setDependentInfoLoading(false)
                    if (res.success) {
                        for (const [, value] of Object.entries(res.data)) {
                            childRows = dependInfoTransformData(value);
                        }
                        children = childRows.map((x: any) => {
                            return { ...x, isChildren: true };
                        });
                        newRows.splice(Number(rowIndex) + 1, 0, ...children);
                        newRows[rowIndex] = { ...row, isExpanded: !row.isExpanded, children };
                        const newUpdatedRows = [...newRows];
                        setAddedSchedulesList(newUpdatedRows);
                        addSchData = newUpdatedRows
                        const stBoxRows: any = localStorage.getItem('boxRows');
                        const tempRows = [{
                            jobId: row.jobId,
                            projectId: String(prjid),
                            children: children
                        }]
                        if (stBoxRows) {
                            let tempStorageBoxRows = JSON.parse(stBoxRows)
                            tempStorageBoxRows = tempStorageBoxRows.concat(tempRows);
                            localStorage.setItem('boxRows', JSON.stringify(tempStorageBoxRows))
                        } else {
                            localStorage.setItem('boxRows', JSON.stringify(tempRows))
                        }
                    }
                })
            }
        } else {
            newRows.splice(Number(rowIndex) + 1, row.children.length);
            newRows[rowIndex] = { ...row, isExpanded: !row.isExpanded };
            const newUpdatedRows = [...newRows];
            setAddedSchedulesList(newUpdatedRows);
            addSchData = newUpdatedRows
        }
    }

    let addSchData: any = [];

    const getAddedScheduleList = async (
        page: number = 1,
        size: number = 100,
        filter: any = {},
        sortingInfo: any = {}
    ) => {
        const colFilterInfo = normalizeFilter(filter);
        let effectiveProjectId;
        if (isProjectChanged && selectedProjectId !== null) effectiveProjectId = selectedProjectId;
        else effectiveProjectId = String(prjid);

        let params = {
            projectId: effectiveProjectId,
            platformName:platformName,
            page,
            size,
            filter: colFilterInfo,
            sortBy: sortingInfo.sortBy || '',
            orderBy: sortingInfo.sortDir || ''
        };
        setScheduleTableLoading(true);
        let result
        result = await getAddedSchedules(params);
        if (result.success) {
            setScheduleTableLoading(false);
            let jobArr = result.data.selectedJobData;
            let reqData: any = [];
            jobArr.map((data: any, index: number) => {
                data['className'] = 'l1';
                data['isExpanded'] = false;
                data['dependInfo'] = data.dependInfo?.length ? data.dependInfo : [];
                data['isParent'] = true;
                data['eleLevel'] = 'l' + index;
                reqData.push(data);
            });

            setAddedSchedulesList(reqData);
            const pipelineData: PipelineOption[] = reqData.map((row: any) => {
                const jobId = String(row?.jobId);
                const jobName = row?.jobName;
                const triggerName = row?.triggerName;
                const pipeline_param = row?.pipeline_param || {};
                return jobId && jobName ? { jobId, jobName, pipeline_param, triggerName } : null;
                })
                .filter(Boolean) as PipelineOption[];

            setPipelines(pipelineData);
            
            addSchData = reqData;
            let filterOptionCon: any = {
                jobName: [],
                platformId: []
            }
            if (result.data.filterOptions) {
                filterOptionCon = transformFilterOptions(result.data.filterOptions);
            }
            setFilterData(filterOptionCon)
            setPaginationDataSchedule(result.data.page);
            setPageSchedule(result.data.page.currentPage);
            setPageSizeSchedule(result.data.page.size);
        }
    };

    const handleSorting = (sortingInfo: any) => {
        if (parseFilter(sortingInfo).sortBy == 'platform') {
            let parsedData = parseFilter(sortingInfo);
            parsedData['sortBy'] = 'Platform_Id';

            setSortingInfo(parsedData);
        } else {
            setSortingInfo(sortingInfo);
            getAddedScheduleList(Number(page), Number(pageSize), parseFilter(filterInfo), sortingInfo);
        }
    };

    const handleJobNameFilter = (filterData: any, parsedData: any) => {
        let filterFormat: any = {
            ...parsedData,
            Project_Schedule_ID: []
        };
        for (const data of parsedData['Job_Name']) {
            let filteredData: any = addedSchedulesList.filter((fil: any) => fil.Job_Name == data);
            if (filteredData.length) {
                filterFormat.Project_Schedule_ID = filteredData.map((data: any) => data.Project_Schedule_ID);
            }
        };
        if (!Object.keys(filterFormat).includes('Job_Name')) {
            filterFormat = {};
        }
        setFilterInfo(filterFormat);
        getAddedScheduleList(Number(page), Number(pageSize), filterFormat, sortingInfo);
    };

    const handlePlatformFilter = (filterData: any, parsedData: any) => {
        parsedData['Platform_Id'] = [];
        for (const data of parsedData['platform']) {
            if (data === 'Teradata') {
                parsedData['Platform_Id'].push(1);
            }
        };
        setFilterInfo(filterData);
        delete parsedData.platform;
        getAddedScheduleList(Number(page), Number(pageSize), parsedData, sortingInfo);
    };

    const handleStartTimeFilter = (filterData: any, parsedData: any) => {
        const start = parsedData['Start_Time'];
        parsedData['Days'] = [];
        parsedData['Start_Time'] = [];
        parsedData['Project_Schedule_ID'] = [];
        
        for (const data of start) {
            let obj = convertDayTime(data);
            parsedData['Start_Time'].push(obj.time);
            parsedData['Days'].push(obj.day);
        };
        
        for (const [index, data] of parsedData['Days'].entries()) {
            let filteredData: any = addedSchedulesList.filter(
                (fil: any) => fil.Days == data && fil.Start_Time == parsedData['Start_Time'][index]
            );
            if (filteredData.length) {
                parsedData.Project_Schedule_ID = filteredData.map((data: any) => data.Project_Schedule_ID);
            }
        };
        setFilterInfo(filterData);
        getAddedScheduleList(Number(page), Number(pageSize), parsedData, sortingInfo);
    };

    const handleNormalCompletionTimeFilter = (filterData: any, parsedData: any) => {
        const start = parsedData['normalCompletionTime'];
        parsedData['Normal_Completion_Time'] = [];
        parsedData['Project_Schedule_ID'] = [];
        
        for (const data of start) {
            parsedData['Normal_Completion_Time'].push(convertTimeToNumber(data));
        };
        
        for (const data of parsedData['Normal_Completion_Time']) {
            let filteredData: any = addedSchedulesList.filter((fil: any) => fil.Normal_Completion_Time == data);
            if (filteredData.length) {
                parsedData.Project_Schedule_ID = filteredData.map((data: any) => data.Project_Schedule_ID);
            }
        };
        setFilterInfo(filterData);
        delete parsedData.normalCompletionTime;
        getAddedScheduleList(Number(page), Number(pageSize), parsedData, sortingInfo);
    };

    const handleFilter = (filterData: any, tableType: string) => {
        if (tableType == 'add-schedules') {
            setTableLoading(true);
            // Filter from original search results, not from already-filtered data
            let filtered = [...originalTableDataList];
            for (const [key, values] of Object.entries(filterData) as any) {
                if (Array.isArray(values) && values.length > 0) {
                    filtered = filtered.filter((row: any) => values.includes(row[key]));
                } else if (typeof values === 'string' && values) {
                    filtered = filtered.filter((row: any) => row[key] === values);
                }
            }
            setTableDataList(filtered);
            setFilterInfoSearch(filterData);
            setTableLoading(false);
            return;
        }
        setAddedSchedulesList([]);
        setScheduleTableLoading(true);
        
        if (filterData.Project_Schedule_ID) {
            delete filterData.Project_Schedule_ID;
        }

        const parsedData = parseFilter(filterData);
        const filterKeys = Object.keys(parsedData);

        if (filterKeys.includes('Job_Name')) {
            handleJobNameFilter(filterData, parsedData);
        } else if (filterKeys.includes('platform')) {
            handlePlatformFilter(filterData, parsedData);
        } else if (filterKeys.includes('Start_Time')) {
            handleStartTimeFilter(filterData, parsedData);
        } else if (filterKeys.includes('normalCompletionTime')) {
            handleNormalCompletionTimeFilter(filterData, parsedData);
        } else {
            setFilterInfo(filterData);
            getAddedScheduleList(Number(page), Number(pageSize), parsedData, sortingInfo);
        }
    };

    const handleHeaderSelectAll = (event: any) => {
        selectedRowsId = [];
        let tempSelectedRows: any = [];
        for (const row of tableDataList) {
            row.selected = event.target.checked;
            if (event.target.checked) {
                selectedRowsId.push(row.id);
            }
        }
        if (event.target.checked) {
            tempSelectedRows = tableDataList;
        }
        setSelectedRows(tempSelectedRows);

        setTableDataList([...tableDataList]);

        reqRows = tempSelectedRows;

        let inputElements: any = document.getElementsByClassName('row-checkbox');

        for (const inputElement of inputElements) {
            if (inputElement instanceof HTMLInputElement) {
                inputElement.checked = event.target.checked;
            }
        }
    };

    const handlePageChange = (event: ChangeEvent<unknown>, value: string) => {
        searchScheduleFunc(requestBody, value, pageSize);
    };
    const handlepageSizeChange = (event: any) => {
        searchScheduleFunc(requestBody, page, event.target.value);
    };

    const handlePageChangeSchedule = (event: ChangeEvent<unknown>, value: string) => {
        getAddedScheduleList(Number(value), Number(pageSize));
    };

    const handlepageSizeChangeSchedule = (event: any) => {
        getAddedScheduleList(Number(page), event.target.value);
    };

    const updateSelectionFlags = (filterData: any[]) => {
        for (const fil of filterData) {
            if (fil.filterType === `${singularLabelName} Name` && fil.keywords) {
                setSelectedJobName(true);
            }
        }
        for (const fil of filterData) {
            if (fil.filterType === `${labels.adbGoldTable} Name` && fil.keywords) {
                setSelectedGoldTableName(true);
            }
        }
        for (const fil of filterData) {
            if (fil.filterType == 'Folder Name' && fil.keywords) {
                setSelectedFolderName(true);
            }
        }
    };

    const handleOnClose = (event: any, index: number, autoValue?: any) => {
        if (autoValue !== 'selectOption') return;
        const {
            target: { textContent }
        } = event;
        const filterData = [...filterCriteria];
        filterData[index]['keywords'] = textContent;
        if (textContent) {
            for (const job of jobDataList) {
                if (job.JobName === textContent) {
                    filterData[index]['id'] = job.JobId;
                }
            }
        }

        updateSelectionFlags(filterData);
        setFilterCriteria(filterData);
    };

    const resetListStates = () => {
        setJobNameList([]);
        setDataAssetNameList([]);
        setSilverTableNameList([]);
        setAdfNameList([]);
        setAdbWorkspaceNameList([]);
        setAdbGoldTableNameList([]);
        setFolderNameList([]);
    };

    const clearSearchKeywords = () => {
        setJobSearchKeyword('');
        setAdbWorkspaceSearchKeyword('');
        setDataAssetSearchKeyword('');
        setSilverTableSearchKeyword('');
        setAdfSearchKeyword('');
        setFolderSearchKeyword('');
        setAdbGoldTableSearchKeyword('');
    };

    const clearSelectionFlags = () => {
        setSelectedJobName(false);
        setSelectedFolderName(false);
        setSelectedGoldTableName(false);
    };

    const updateSelectedFlags = (filters: any[], type?: string) => {
        const filter = filters.find(f => f.filterType === type && f.keywords);
        if (!filter) return;

        const flagMap: Record<string, Function> = {
            [`${singularLabelName} Name`]: setSelectedJobName,
            [`${labels.adbGoldTable} Name`]: setSelectedGoldTableName,
            'Folder Name': setSelectedFolderName,
        };

        const fn = flagMap[type!];
        if (fn) fn(true);
    };

    const updateAllJobNameIds = (filterData: any[]) => {
        let jobNameArr = filterData.filter((obj: any) => obj.filterType == `${singularLabelName} Name`);
        if (jobNameArr.length) {
            for (const obj of jobNameArr) {
                for (const job of jobDataList) {
                    if (job.JobName === obj.keywords) {
                        const pos = filterData.findIndex((data: any) => data.keywords === obj.keywords);
                        if (pos !== -1) {
                            filterData[pos]['id'] = job.JobId;
                        }
                    }
                }
            }
        }
    };

     const assignAutoValueId = (filterData: any[], index: number, selectedFilterType?: string, autoValue?: string) => {
        if (!selectedFilterType || !autoValue) return;

        const operations: Record<string, (val: string) => any> = {
            [`${singularLabelName} Name`]: (val) =>
                jobDataList.find(j => j.JobName === val)?.JobId,

            Dataset: (val) =>
                datasetList.find(d => d.NAME === val)?.ID,

            Workspace: (val) =>
                workspaceList.find(w => w.name === val)?.orgId,

            capacity: (val) =>
                capacityList.find(c => c.displayname === val)?.capacityId
        };

        const getId = operations[selectedFilterType];
        if (!getId) return;

        const id = getId(autoValue);
        if (id) filterData[index].id = id;
    };

    const assignFilterId = (filterData: any[], index: number, selectedFilterType?: string, autoValue?: string) => {
        if (!selectedFilterType || !autoValue) return;
        assignAutoValueId(filterData, index, selectedFilterType, autoValue);
        updateAllJobNameIds(filterData);
        return filterData;
    };

    const handleFolderFilterRules = (filters: any[], schedulerValue: string) => {
        const schArr = ['HWA', 'Control-M'];
        const isTeradata = platformName === 'All' || platformName === 'Teradata';

        if (isTeradata && schArr.includes(schedulerValue)) {
            return filters.filter(f => f.filterType !== 'Folder Name');
        }

        return filters;
    };

    const handleChangeDynamicKeywords = (
        event: any,
        index: number,
        autoValue?: any,
        selectedFilterType?: string
    ) => {
        resetListStates();
        const {
            target: { value }
        } = event;
        let filterData = [...filterCriteria];

        filterData = handleFolderFilterRules(filterData, event.target.value);
        filterData[index]['keywords'] = autoValue ?? value;
        
        // If Scheduler Name changed, remove Folder Name filter if scheduler is not Control-M or Control-M-PGT
        if (selectedFilterType === 'Scheduler Name' && filterData[index]['keywords']) {
            const schedulerValue = filterData[index]['keywords'];
            const schedulerStr = Array.isArray(schedulerValue) ? schedulerValue[0] : schedulerValue;
            if (schedulerStr && !['Control-M', 'Control-M-PGT'].includes(schedulerStr)) {
                filterData = filterData.filter(f => f.filterType !== 'Folder Name');
            }
        }
        
        assignFilterId(filterData, index, selectedFilterType, autoValue);
        updateSelectedFlags(filterData, selectedFilterType);
        setFilterCriteria(filterData);
    };

    const debouncedFetchOptions = useMemo(
        () =>
            debounce(async (filterData, value, type: string, platform: string) => {
                const labels = getPlatformLabels(platformName);
                if (type == `${singularLabelName} Name`) {
                    jobNameListFunc(platform, filterData[0].keywords, value, filterData);
                }
                else if (type == `${labels.dataAsset} Name`) {
                    dataAssetFunc(platform, filterData[0].keywords, value, filterData);
                }
                else if (type == `${labels.silverTable} Name`) {
                    silverTableFunc(platform, filterData[0].keywords, value, filterData);
                }
                else if (type == 'Instance Name') {
                    instanceListFunc(platform, filterData[0].keywords, value, filterData);
                }
                else if (type == 'Workspace Name') {
                    workspaceListFunc(platform, filterData[0].keywords, value, filterData);
                }
                else if (type == 'Folder Name') {
                    folderNameListFunc(platform, filterData[0].keywords, value, filterData);
                } else if (type == `${labels.adbGoldTable} Name`) {
                    adbGoldTableNameListFunc(value, filterData);
                }
            }, 500),
        [platformName]
    );
    const onChangeFieldKeyDown = (event: any) => {
        const allowedKeys = [
            "Backspace",
            "Tab",
            "Enter",
            "Escape",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Delete"
        ];

        const allowedRegex = /^[0-9a-zA-Z/()[\]&+'"%*#:@!?_.-]$/;

        if (!allowedRegex.test(event.key) && !allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
    };


    const handleFieldInputTypeState = (type: string, valueTrim: string) => {
        const typeHandlers: Record<string, () => void> = {
            [`${singularLabelName} Name`]: () => { setJobSearchKeyword(valueTrim); setSearchJobNameInputLoading(true); },
            [`${labels.adbWorkspace} Name`]: () => { setAdbWorkspaceSearchKeyword(valueTrim); setSearchWorkspaceInputLoading(true); },
            [`${labels.adbGoldTable} Name`]: () => { setAdbGoldTableSearchKeyword(valueTrim); setSearchGoldTableInputLoading(true); },
            [`${labels.dataAsset} Name`]: () => { setDataAssetSearchKeyword(valueTrim); setSearchDataAssetInputLoading(true); },
            [`${labels.silverTable} Name`]: () => { setSilverTableSearchKeyword(valueTrim); setSearchSilverTableInputLoading(true); },
            'Instance Name': () => { setAdfSearchKeyword(valueTrim); setSearchAdfNameInputLoading(true); setAdfAdded(true); },
            'Folder Name': () => { setFolderSearchKeyword(valueTrim); setSearchFolderNameInputLoading(true); },
        };
        
        const handler = typeHandlers[type];
        if (handler) handler();
    };

    const onChangeFieldInput = (event: any, index: number, type: string) => {
        const {
            target: { value }
        } = event;
        const valueTrim = value.trim();
        const filterData = [...filterCriteria];
        filterData[index]['keywords'] = valueTrim;
        setFilterCriteria(filterData);
        setSelectedJobName(false);
        setSelectedGoldTableName(false);
        setSelectedFolderName(false);
        if (valueTrim && valueTrim.length > 0) {
            handleFieldInputTypeState(type, valueTrim);
            debouncedFetchOptions(filterData, valueTrim, type, platformName);
        }
    };

    const schedulerDefaultConfig = (labels: any, schedulerName: string) => ({
        filters: [
            { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: schedulerName },
            { filterType: 'Job Name', operation: 'Equals to (=)', keywords: '', id: 1 }
        ],
        list: ['Scheduler Name', `${singularLabelName} Name`]
    });

    const getPlatformADFConfig = () => {
        const labels = getPlatformLabels('ADF');
        return {
            filters: [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'All' },
                { filterType: 'Instance Name', operation: 'Equals to (=)', keywords: '' },
                { filterType: 'Pipeline Name', operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            list: [
                'Scheduler Name',
                'Instance Name',
                `${singularLabelName} Name`,
                `${labels.dataAsset} Name`,
                `${labels.silverTable} Name`
            ]
        };
    };

    const getADBConfig = () => {
        setPlatformName('ADB');
        const labels = getPlatformLabels('ADB');
        return {
            filters: [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'ADB' },
                { filterType: `${labels.adbWorkspace} Name`, operation: 'Equals to (=)', keywords: '', id: 1 },
                { filterType: 'Job Name', operation: 'Equals to (=)', keywords: '', id: 2 }
            ],
            list: ['Scheduler Name', `${labels.adbWorkspace} Name`, `${singularLabelName} Name`]
        };
    };

    const platformConfigMap = {
        'Power BI': () => ({
            filters: [
                { filterType: 'Capacity', operation: 'Equals to (=)', keywords: '' },
                { filterType: 'Workspace', operation: 'Equals to (=)', keywords: '' },
                { filterType: 'Dataset', operation: 'Equals to (=)', keywords: '' }
            ],
            list: ['Capacity', 'Workspace', 'Dataset']
        }),
        'BODS': () => ({
            filters: [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'Control-M-PGT' },
                { filterType: 'Job Name', operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            list: ['Scheduler Name', `${singularLabelName} Name`, 'Folder Name']
        }),
        'Teradata': () => ({
            filters: [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'Control-M' },
                { filterType: 'Job Name', operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            list: ['Scheduler Name', `${singularLabelName} Name`, 'Folder Name']
        }),
        'DDH': () => ({
            filters: [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'All' },
                { filterType: 'Job Name', operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            list: ['Scheduler Name', `${singularLabelName} Name`]
        }),
        'MDT': () => ({
            filters: [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'All' },
                { filterType: 'Job Name', operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            list: ['Scheduler Name', `${singularLabelName} Name`]
        }),
        'ADF': getPlatformADFConfig,
        'ADB': getADBConfig,
    };

    const getPlatformConfig = (value: string) => {
        const platforms = ['Windows Server', 'SAP BW', 'SQL Server Agent (NewsPage)', 'IICS'];
        
        const configHandler = platformConfigMap[value as keyof typeof platformConfigMap];
        if (configHandler) return configHandler();
        
        if (platforms.includes(value)) {
            const labels = getPlatformLabels(value);
            const schedulerMap: Record<string, string> = {
                'Windows Server': 'Windows Task Scheduler',
                'SAP BW': 'SAP BW',
                'SQL Server Agent (NewsPage)': 'SQL Server',
                'IICS': 'IICS'
            };
            return schedulerDefaultConfig(labels, schedulerMap[value]);
        }

        // DEFAULT CASE
        return {
            filters: [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'All' },
                { filterType: 'Job Name', operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            list: ['Scheduler Name', `${singularLabelName} Name`, 'Folder Name']
        };
    };

    const resetPlatformState = (value: string) => {
        setSearchScheduleBtn(false);
        setPlatformName(value);
        setFilterCriteria([]);
        setAdfAdded(false);
        clearSearchKeywords();
        resetListStates();
    };

    const handleChangePlatform = (event: SelectChangeEvent<typeof platformName>) => {
        const {
            target: { value }
        } = event;

        resetPlatformState(value);
        const config = getPlatformConfig(value);

        if (config) {
            setFilterCriteria(config.filters);
        }
    };

    const handleChangeDynamicFilter = (event: any, index: number) => {
        const { target: { value } } = event;
        let filterData = [...filterCriteria];

        filterData[index].filterType = value;
        if (value == 'Days') {
            filterData[index].keywords = []
            filterData[index]['id'] = index;
        } else if (value == `${singularLabelName} Name` || value == `${labels.silverTable} Name`
            || value == `${labels.dataAsset} Name` || value == 'Folder Name') {
            filterData[index].id = index;
            filterData[index].keywords = '';
        }
        else if (value == 'Start Time') {
            filterData[index].fromTime = '';
            filterData[index].toTime = '';
            filterData[index].fromTimeValue = '';
            filterData[index].toTimeValue = '';
        }
        setHasSchedulerAdded(false);
        setHasInstanceAdded(false);
        for (const fil of filterData) {
            if (fil.filterType == 'Scheduler Name') {
                setHasSchedulerAdded(true);
            } else if (fil.filterType == 'Instance Name') {
                setHasInstanceAdded(true);
            }
        }
        
        if (platformName === 'ADB') {
            const isJobName = value === `${singularLabelName} Name`;
            const isGoldTableName = value === `${labels.adbGoldTable} Name`;

            if (isJobName || isGoldTableName) {
                filterData = filterData.filter((f, idx) => {
                    if (idx === index) return true;
                    if (isJobName && f.filterType === `${labels.adbGoldTable} Name`) {
                        return false;
                    }
                    if (isGoldTableName && f.filterType === `${singularLabelName} Name`) {
                        return false;
                    }
                    return true;
                });
            }
        }
        
        setFilterCriteria(filterData);
    };

    const handleAddFilter = (index: any) => {
        resetListStates();
        const instanceCount = filterCriteria.filter(f => f.filterType === 'Instance Name').length;
        const workspaceCount = filterCriteria.filter(f => f.filterType === 'Workspace Name').length;
        const hasGoldTableName = filterCriteria.some(f => f.filterType === `${labels.adbGoldTable} Name`);

        let newFilterData;

        if (platformName === 'Power BI') {
            newFilterData = { filterType: 'Capacity', operation: 'Equals to (=)', keywords: '' };
        } else if (!hasSchedulerAdded) {
            newFilterData = { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: '' };
        } else if (instanceCount === 0 && platformName === 'ADF') {
            newFilterData = { filterType: 'Instance Name', operation: 'Equals to (=)', keywords: '' };
            setHasInstanceAdded(true);
        } else if (workspaceCount === 0 && platformName === 'ADB') {
            newFilterData = { filterType: 'Workspace Name', operation: 'Equals to (=)', keywords: '' };
        } else if (platformName === 'ADB' && hasGoldTableName ) {
            newFilterData = { filterType: `${labels.adbGoldTable} Name`, operation: 'Equals to (=)', keywords: '' };
        } else {
            newFilterData = { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '' };
        }
        if (index == -1) {
            filterCriteria.unshift(newFilterData);
        } else {
            filterCriteria.push(newFilterData);
        }
        const insertedFilterCriteria = filterCriteria;
        setFilterCriteria([...insertedFilterCriteria]);
    };

    const handleRemoveFilter = (index: any) => {
        resetListStates();
        const filterData = [...filterCriteria];
        if (filterData[index].filterType == 'Scheduler Name') {
            setHasSchedulerAdded(false);
        } else if (filterData[index].filterType == 'Instance Name') {
            setHasInstanceAdded(false);
        }
        filterData.splice(index, 1);
        setFilterCriteria([...filterData]);
    };

    const getResetFilterData = (platformName: string): any[] => {
        const resetDataMap: Record<string, any[]> = {
            'Power BI': [
                { filterType: 'Capacity', operation: 'Equals to (=)', keywords: '' },
                { filterType: 'Workspace', operation: 'Equals to (=)', keywords: '' },
                { filterType: 'Dataset', operation: 'Equals to (=)', keywords: '' }
            ],
            'BODS': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'Control-M-PGT' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            'Teradata': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'Control-M' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
        };

        if (resetDataMap[platformName]) return resetDataMap[platformName];

        const resetMap: Record<string, any[]> = {
            'ADF': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'All' },
                { filterType: 'Instance Name', operation: 'Equals to (=)', keywords: '' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            'Windows Server': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'Windows Task Scheduler' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            'SAP BW': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'SAP BW' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            'SQL Server Agent (NewsPage)': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'SQL Server' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            'IICS': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'IICS' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '', id: 1 }
            ],
            'ADB': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'ADB' },
                { filterType: `${labels.adbWorkspace} Name`, operation: 'Equals to (=)', keywords: '', id: 1 },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '', id: 2 }
            ],
        };
        return resetMap[platformName] ?? [];
    };

    const handleClear = () => {
        clearSelectionFlags();
        setSearchScheduleBtn(false);
        clearSearchKeywords();
        setAdfAdded(false);
        resetListStates();
        setDatasetNameList([]);
        setWorkspaceNameList([]);
        setCapacityNameList([]);
        setFilterInfoSearch([]);
        // Reset search table to show all original search results without filter
        if (originalTableDataList.length > 0) {
            setTableDataList([...originalTableDataList]);
        }

        localStorage.removeItem('add-schedules_user_col_pref'); //Reset the user column preferences for add schedules table
        localStorage.removeItem('added-schedules_user_col_pref'); //Reset the user column preferences for added schedules table
        
        const filterData = getResetFilterData(platformName);
        setFilterCriteria(filterData);
    };

    const onSubmitSearchFetchJobIds = () => {
        setSelectedRows([]);
        handleOnSubmit(filterCriteria);
    }

    const openBulkUploadModal = () => {
        setBulkUploadModal(true)
    }

    const initializeReqBody = (filterCriteriaData: any) => {
        let reqBody: any = { 
            schedulerType: filterCriteriaData[0].keywords, 
            jobIds: [], 
            days: [], 
            startTime: [], 
            projectId: prjid, 
            platformName: platformName, 
            folderName: [], 
            dataAssetName: [], 
            silverTableName: [],
            goldTableNames: []
        };

        if (platformName === 'Power BI') {
            reqBody = { dsName: '', wkName: '', cpName: '' };
        }
        if (platformName === 'ADF') {
            const instanceFilter = filterCriteriaData.find((f: any) => f.filterType === 'Instance Name');
            if (instanceFilter?.keywords) {
                reqBody.adfName = instanceFilter.keywords;
            }
        }
        if (platformName === 'ADB') {
            const instanceFilter = filterCriteriaData.find((f: any) => f.filterType === 'Workspace Name');
            if (instanceFilter?.keywords) {
                reqBody.workspaceName = instanceFilter.keywords;
            }
        }
        return reqBody;
    };

    const processFilterItem = (filter: any, reqBody: any, flags: any) => {
        const { keywords, filterType } = filter;
        if (!keywords) return;

        const filterMap: Record<string, () => void> = {
            'Scheduler Name': () => { flags.hasSchedulerType = true },
            [singularLabelName + ' Name']: () => {
                flags.hasJobName = true;
                if (selectedJobName && !filter.id) {
                    reqBody.jobIds = [];
                } else {
                    reqBody.jobIds.push(keywords);
                }
            },
            [labels.dataAsset + ' Name']: () => {
                flags.hasJobName = true;
                reqBody.dataAssetName.push(keywords);
            },
            [labels.silverTable + ' Name']: () => {
                flags.hasJobName = true;
                reqBody.silverTableName.push(keywords);
            },
            'Folder Name': () => {
                flags.hasFolderName = true;
                reqBody.folderName.push(keywords);
            },
            'Dataset': () => {
                flags.hasDatasetName = true;
                reqBody.dsName = keywords;
            },
            'Workspace': () => {
                flags.hasWorkspaceName = true;
                reqBody.wkName = keywords;
            },
            'Capacity': () => {
                flags.hasCapacityName = true;
                reqBody.cpName = keywords;
            },
            [labels.adbGoldTable + ' Name']: () => {
                flags.hasGoldTableName = true;
                if (selectedGoldTableName && !filter.id) {
                    reqBody.goldTableNames = [];
                } else {
                    reqBody.goldTableNames.push(keywords);
                }
            },
        };

        const handler = filterMap[filterType];
        if (handler) {
            handler();
        }

        if (flags.hasSchedulerType && flags.hasJobName && filterType === 'Days') {
            reqBody.days = keywords.includes('All')
                ? 'all'
                : keywords.map((d: string) => d.substring(0, 2).toLowerCase());
        }

        if (flags.hasSchedulerType && flags.hasJobName && filterType === 'Start Time' &&
            filter.fromTimeValue && filter.toTimeValue) {
            reqBody.startTime = [filter.fromTimeValue, filter.toTimeValue];
        }
    };

    const handleOnSubmit = (filterCriterias?: any) => {
        let filterCriteriaData = [];
        if (filterCriterias && filterCriteria.length) {
            filterCriteriaData = filterCriterias;
        }
        const flags = {
            hasJobName: false,
            hasDatasetName: false,
            hasWorkspaceName: false,
            hasCapacityName: false,
            hasSchedulerType: false,
            hasFolderName: false,
            hasGoldTableName: false,
        };
        
        const reqBody = initializeReqBody(filterCriteriaData);

        for (const filter of filterCriteriaData) {
            processFilterItem(filter, reqBody, flags);
        }

        const hasValidFilters = flags.hasFolderName || flags.hasJobName || flags.hasDatasetName ||
            flags.hasWorkspaceName || flags.hasCapacityName || flags.hasGoldTableName;

        if (hasValidFilters) {
            setSearchScheduleBtn(true);
            setRequestBody(reqBody);
            searchScheduleFunc(reqBody, '1', '100');
        }
    };

    const buildPowerBIBody = (row: any) => ({
        dsName: row.dsName,
        dsId: row.dsId,
        platformId: platformName === 'Power BI' ? 2 : 1,
        programId: Number(prgmid),
        projectId: Number(prjid),
        isEnabled: row.enabled
    });

    const buildDefaultBody = (row: any) => ({
        JobName: row.jobName,
        ADFName: row.adfName,
        triggerName: row.triggerName,
        silverTableName: row.silverTableName,
        dataAssetName: row.dataAssetName,
        scheduleInfo: row.scheduleInfo,
        JobId: row.jobId,
        SLAODate: row.SLAODate ? row.SLAODate : 0,
        Scheduler: row.Scheduler,
        SLATime: row.SLATime == '' || !row.SLATime ? null : Number(row.SLATime.replace(':', '')),
        ProgramId: String(prgmid),
        ProjectId: String(prjid),
        Cyclic: row.cyclic,
        platformName: row.Platform ? row.Platform : platformName,
        platformId: row.platformId,
        workspaceName:row.workspaceName,
        workspaceId:row.workspaceId,
        goldTableName:row.goldTableName, 
        folderName: row.folderNames, 
        subFolderName:row.subFolderNames,
        application:row.application, 
        marketUnitName:row.marketUnitName
    });

    const addSchedulesToProject = () => {
        if (!selectedRows.length) return;
        const isPowerBI = platformName === 'Power BI';
        const reqBodySch = selectedRows.map((row: any) =>
            isPowerBI ? buildPowerBIBody(row) : buildDefaultBody(row)
        );
        addScheduleToProjectFunc(reqBodySch);
    };

    async function addScheduleToProjectFunc(reqBody: any) {
        setAddProjectLoading(true);

        try {
            const res = await linkAddScheduleToProject(reqBody);
            if (res.statusCode == 200) {
                setSuccessMsg(res.data.message);
                setSuccessCount(res.data.addedJobs);
                if (!bulkUploadModal) {
                    setOpenModal({
                        isOpen: true
                    });
                }
            } else if (res.code == 'ERR_BAD_REQUEST') {
                setSuccessMsg('Schedules already added!');
                if (!bulkUploadModal) {
                    setOpenModal({
                        isOpen: true
                    });
                }
            }
        } finally {
            setAddProjectLoading(false);
        }
    }

    async function instanceListFunc(platformName: any, schedulerType: string, adfName?: string, filterData?: any) {
        const res = await getADFNameList(platformName, schedulerType, adfName, Number(prjid))
        if (res.success) {
            setSearchAdfNameInputLoading(false);
            setAdfNameList(res.data.jobNames.map((jn: any) => jn.adfName));
        }
    }

    async function workspaceListFunc(platformName: any, schedulerType: string, adbWorkspaceName?: string, filterData?: any) {
        const res = await getADBWorkspaceNameList(platformName, schedulerType, adbWorkspaceName, Number(prjid))
        if (res.success) {
            setSearchWorkspaceInputLoading(false);
            setAdbWorkspaceNameList(res.data.workspaceNames.map((jn: any) => jn.WorkspaceName));
        }
    }

    const getAdfNameFromFilter = (filterData: any): string => {
        if (!Array.isArray(filterData)) return '';
        const instanceFilter = filterData.find((f: any) => f.filterType === 'Instance Name');
        return instanceFilter ? instanceFilter.keywords : '';
    };

    const handleJobNameResponse = (res: any) => {
        if (!res?.success) return;

        setJobDataList(res.data.jobNames);
        setSearchJobNameInputLoading(false);
        setJobNameList(res.data.jobNames.map((jn: any) => jn.JobName));
    };

    async function jobNameListFunc(platformName: any, schedulerType: string, jobName?: string, filterData?: any) {
        const projectId = Number(prjid);
        let res;

        const platformMap: Record<string, () => Promise<any>> = {
            'Windows Server': () => searchWindowsJobNameList(platformName, schedulerType, jobName, projectId),
            'SAP BW': () => searchSAPBWJobNameList(platformName, schedulerType, jobName, projectId),
            'SQL Server Agent (NewsPage)': () => searchSqlAgentJobNameList(platformName, schedulerType, jobName, projectId),
            'IICS': () => searchIicsJobNameList(platformName, schedulerType, jobName, projectId),
            'DDH': () => searchDDHJobNameList(platformName, schedulerType, jobName, projectId),
            'MDT': () => searchMDTJobNameList(platformName, schedulerType, jobName, projectId),
            'BODS': () => getTeradataJobNameList(platformName, schedulerType, jobName, projectId),
            'Teradata': () => getTeradataJobNameList(platformName, schedulerType, jobName, projectId),
            'ADF': () => {
                const adfName = getAdfNameFromFilter(filterData);
                return searchADFNameList(platformName, schedulerType, adfName, jobName, projectId);
            },
            'ADB': () => { 
                let workspaceName = '';
                if (Array.isArray(filterData)) {
                    const instanceFilter = filterData.find((f: any) => f.filterType === 'Workspace Name');
                    workspaceName = instanceFilter ? instanceFilter.keywords : '';
                }
                return searchADBJobNameList(platformName, schedulerType, workspaceName,jobName, Number(prjid));
            }
        };
        
        const fetcher = platformMap[platformName];
        if (fetcher) {
            res = await fetcher();
        } else {
            const adfName = getAdfNameFromFilter(filterData);
            res = await searchADFNameList(platformName, schedulerType, adfName, jobName, projectId);
        }
        handleJobNameResponse(res);
    }
    async function dataAssetFunc(platformName: any, schedulerType: string, dataAsset?: string, filterData?: any) {
        let adfName = '';
        if (Array.isArray(filterData)) {
            const instanceFilter = filterData.find((f: any) => f.filterType === 'Instance Name');
            adfName = instanceFilter ? instanceFilter.keywords : '';
        }
        const res = await searchDataAsset(platformName, schedulerType, adfName, dataAsset, Number(prjid));

        if (res.success) {
            setSearchDataAssetInputLoading(false);
            setDataAssetNameList(res.data.dataAssetNames.map((jn: any) => jn.dataAssetName));
        }
    }

    async function silverTableFunc(platformName: any, schedulerType: string, silverTable?: string, filterData?: any) {
        let adfName = '';
        if (Array.isArray(filterData)) {
            const instanceFilter = filterData.find((f: any) => f.filterType === 'Instance Name');
            adfName = instanceFilter ? instanceFilter.keywords : '';
        }
        const res = await searchSilverTableName(platformName, schedulerType, adfName, silverTable, Number(prjid));
        setSearchSilverTableInputLoading(false);
        setSilverTableNameList(res.data.silverTableNames.map((jn: any) => jn.silverTableName));

    }

    async function folderNameListFunc(platformName: any, schedulerType: string, folderName?: string, filterData?: any) {
        const res = await getFolderNameList(platformName, schedulerType, folderName, Number(prjid));
        if (res.success) {
            setSearchFolderNameInputLoading(false);
            setFolderNameList(res.data.folderNames.map((jn: any) => jn.application));
        }
    }


const getScheduleFetcher = (
  platformName: string,
): ScheduleFetcher => {
  const map: Record<string, ScheduleFetcher> = {
    'Windows Server': getWindowsJobData,
    'SAP BW': getSAPBWJobData,
    'SQL Server Agent (NewsPage)': getSqlAgentJobData,
    'ADB': getADBJobData,
    'IICS': getIicsJobData,
  };

    map['DDH'] = getDDHJobData;
    map['MDT'] = getMDTJobData;
    map['Teradata'] = getTeradataJobData;
    map['BODS'] = getTeradataJobData;

  return map[platformName] ?? getSearchScheduleJobNameList;
};

const handleSearchSuccess = (res: any) => {
  const schListData = res.data.selectedJobData.map(
    (row: any, index: number) => ({
      ...row,
      SLAODate: '',
      SLATime: '',
      selected: false,
      id: index,
    })
  );

  const filterOptions: any = {};
  if (schListData.length > 0) {
    Object.keys(schListData[0]).forEach((key) => {
      filterOptions[key] = Array.from(
        new Set(schListData.map((row: any) => row[key]))
      ).filter(Boolean);
    });
  }

  setFilterDataSearch(filterOptions);
  setOriginalTableDataList(schListData);
  setTableDataList(schListData);
  setPaginationData(res.data.page);
  setPage(res.data.page.currentPage);
  setPageSize(res.data.page.size);
  setFilterInfoSearch([]);
};

async function searchScheduleFunc(
  reqBody: any,
  pageNumber: any,
  pageSize: any,
  filterData?: any
) {
  setTableLoading(true);

  try {
    const fetcher = getScheduleFetcher(platformName);
    const res = await fetcher(reqBody, pageNumber, pageSize, filterData);

    if (res?.success) {
      handleSearchSuccess(res);
    }
  } finally {
    setJobSearchKeyword('');
    setAdbWorkspaceSearchKeyword('');
    setAdfSearchKeyword('');
    setDataAssetSearchKeyword('');
    setSilverTableSearchKeyword('');
    setFolderSearchKeyword('');
    setAdbGoldTableSearchKeyword('');
    setTableLoading(false);
  }
}

    async function adbGoldTableNameListFunc(goldTableName?: string, filterData?: any) {
       let workspaceName = '';
        if (Array.isArray(filterData)) {
            const instanceFilter = filterData.find((f: any) => f.filterType === 'Workspace Name');
            workspaceName = instanceFilter ? instanceFilter.keywords : '';
        }
        const res = await searchADBGoldTableNameList(workspaceName, goldTableName);
        if (res.success) {
            setJobDataList(res.data.goldTableNames);
            setSearchGoldTableInputLoading(false);
            setAdbGoldTableNameList(res.data.goldTableNames.map((gtn: any) => gtn.GoldTableName));
        }
    }

    const getSchedulerOptions = () => {
      const filterConfig = getFilterDropdownConfig(platformName);
      if (!filterConfig || !filterConfig.schedulerOptions) return [];
      return filterConfig.schedulerOptions.map((opt) => ({ label: opt, value: opt }));
    };

    const handleModalClose = () => {
        if (searchScheduleBtn) {
            handleAddMore();
        } else {
            setOpenModal({
                isOpen: false
            });
        }
    };

    const handleAddMore = () => {
        setAddedSchedulesList([]);
        setSelectedRows([]);
        setOpenModal({
            isOpen: false
        });
        getAddedScheduleList();
        handleClear();
    };

    const classes = useStyles();

    useEffect(() => {
        getAddedScheduleList();
        if (projectData?.length > 0 || prjname) {
            handleProjectChange(null, prjname);
        }
    }, [projectData, platformName]);

    useEffect(() => {
        const nonV2Filters: any = {
            BODS: [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'Control-M-PGT' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '' },
            ],
            'Power BI': [
                { filterType: 'Dataset', operation: 'Equals to (=)', keywords: '' },
                { filterType: 'Workspace', operation: 'Equals to (=)', keywords: '' },
                { filterType: 'Capacity', operation: 'Equals to (=)', keywords: '' }
            ]
        };

        const v2Filters: any = {
            'Windows Server': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'Windows Task Scheduler' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '' }
            ],
            'SAP BW': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'SAP BW' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '' }
            ],
            'SQL Server Agent (NewsPage)': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'SQL Server' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '' }
            ],
            'IICS': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'IICS' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '' }
            ],
            ADB: [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'ADB' },
                { filterType: `${labels.adbWorkspace} Name`, operation: 'Equals to (=)', keywords: '' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '' },
            ],
            ADF: [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'All' },
                { filterType: 'Instance Name', operation: 'Equals to (=)', keywords: '' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '' }
            ],
            'Teradata': [
                { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'Control-M' },
                { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '' }
            ]
        };

        // Default base
        const defaultFilter = [
            { filterType: 'Scheduler Name', operation: 'Equals to (=)', keywords: 'All' },
            { filterType: `${singularLabelName} Name`, operation: 'Equals to (=)', keywords: '' }
        ];

        let selectedFilters = defaultFilter;

        // Highest priority (always override first)
        if (nonV2Filters[platformName]) {
            selectedFilters = nonV2Filters[platformName];
        }
        // Next priority: V2 platforms (but only when isV2 = true AND only if non-V2 is not used)
        else if (v2Filters[platformName]) {
            selectedFilters = v2Filters[platformName];
        }
        setFilterCriteria(selectedFilters);

        if (window.location.pathname.includes('/data-pipeline/search-jobs')) {
            const root = document.getElementById('root');
            if (root) {
                document.head.classList.add('theme-bg-blue');
                document.body.classList.add('theme-bg-blue');
            }
        }
    }, [openModal]);

    const getLabel = () => {
        return (
            <Box>
                Program Name*
            </Box>
        );
    };

    useEffect(() => {
        if (isProjectChanged && selectedProjectId !== null) {
            setAddedSchedulesList([]);
            setScheduleTableLoading(true);
            getAddedScheduleList(); // will pick the right projectId inside
        }
        localStorage.removeItem('add-schedules_user_col_pref'); //Reset the user column preferences for add schedules table
        localStorage.removeItem('added-schedules_user_col_pref'); //Reset the user column preferences for added schedules table
    }, [selectedProjectId]);

    const slaTime = queryParams.get('SLA_Time');
    const slaDate = queryParams.get('SLA_Date');
    const projectName = queryParams.get('projectName');
    const projectId = queryParams.get('projectId');

    const handleProjectChange = (event: any, selectedValue: string | null) => {
        if (!selectedValue) return;
        const selectedProject = projectData.find(
            (item: any) => item.Project_Name === selectedValue
        );
        if (selectedProject) {
            const { Project_Id, Project_Name, SLA_Time, SLA_Date } = selectedProject;
            setSelectedProjectId(Project_Id);
            setIsProjectChanged(true);

            const baseUrl = `/data-pipeline/programs-tab?programID=${prgmid}&programName=${prgname}&projectName=${Project_Name}&projectId=${Project_Id}`;
            const isEditedParam = isEdited === 'true' ? '&isEdited=true' : '';

            if (selectedProject?.slaData?.length > 0) {
                navigate(`${baseUrl}&sladata=${encodeURIComponent(JSON.stringify(selectedProject.slaData[0]))}${isEditedParam}`);
            }
            else {
                navigate(`${baseUrl}&SLA_Time=${SLA_Time}&SLA_Date=${SLA_Date}${isEditedParam}`);
            }
        }
        else if (slaTime && slaDate) {
            const isEditedParams = isEdited === 'true' ? '&isEdited=true' : '';
            const baseUrl = `/data-pipeline/programs-tab?programID=${prgmid}&programName=${prgname}&projectName=${projectName}&projectId=${projectId}`;
            navigate(`${baseUrl}&SLA_Time=${slaTime}&SLA_Date=${slaDate}&tab=2${isEditedParams}`);

        }
    };

    const SIMPLE_PLATFORMS = ['MDT', 'DDH', 'Windows Server', 'SAP BW', 'SQL Server Agent (NewsPage)', 'ADB', 'IICS'];

    const checkV2SimpleJobEnabled = () => {
        return !((adbWorkspaceSearchKeyword && (jobSearchKeyword || adbGoldTableSearchKeyword)) || jobSearchKeyword || selectedJobName || adbGoldTableSearchKeyword || selectedGoldTableName);
    };

    const checkV2ComplexJobEnabled = () => {
        const hasJobFilters = selectedFolderName || folderSearchKeyword || selectedJobName || jobSearchKeyword;
        const hasADFRequirements = selectedJobName || jobSearchKeyword || silverTableSearchKeyword || dataAssetSearchKeyword || adbWorkspaceSearchKeyword || selectedGoldTableName || adbGoldTableSearchKeyword;
        const hasADFInstance = adfSearchKeyword || (hasInstanceAdded && adfAdded);
        return !(hasJobFilters || (hasADFRequirements && hasADFInstance));
    };

    const checkV2Enabled = () => {
        return isSimplePlatform ? checkV2SimpleJobEnabled() : checkV2ComplexJobEnabled();
    };

    const isSimplePlatform = SIMPLE_PLATFORMS.includes(platformName);
    const isDisabled = checkV2Enabled();

    const getNoOptionsText = (loading: boolean | null | undefined, label: string) => {
        if (loading === true) return "Loading...";
        if (loading === false) return "No data";
        return label;
    };

    const filterConfig = getFilterDropdownConfig(platformName);

    // Get the selected scheduler from filterCriteria
    const selectedScheduler = filterCriteria.find((f) => f.filterType === 'Scheduler Name')?.keywords;
    const selectedSchedulerStr = Array.isArray(selectedScheduler) ? selectedScheduler[0] : selectedScheduler;

    const filterDropdownOptions = filterConfig
      ? filterConfig.dropdownList.flatMap((obj) => {
          const [field, usage] = Object.entries(obj)[0];
          let isDisabled = false;
          // Disable if usage is "1" and already used in filterCriteria
          if (usage === '1' && filterCriteria.some((f) => f.filterType === field)) {
            isDisabled = true;
          }
          
          // Show Folder Name ONLY if scheduler is Control-M or Control-M-PGT
          if (field === 'Folder Name' && (!selectedSchedulerStr || !['Control-M', 'Control-M-PGT'].includes(selectedSchedulerStr))) {
            return []; // Return empty array to exclude this option
          }
          
          return [{ label: field, value: field, isDisabled }];
        })
      : [];

    const lightDropdownSxProps = {
        backgroundColor: '#EFF6FF !important',
        borderRadius: '4px',
        height: '38px',
        '&.MuiInputBase-root': {
            backgroundColor: '#EFF6FF !important',
            height: '38px'
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#cbd5e1 !important'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#39ACE7 !important'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#39ACE7 !important'
        },
        '& .MuiSelect-select': {
            fontSize: '14px',
            fontWeight: '500',
            color: '#000000 !important',
            backgroundColor: '#EFF6FF !important',
            paddingTop: '8px !important',
            paddingBottom: '8px !important',
            height: '38px',
            display: 'flex',
            alignItems: 'center',
            boxSizing: 'border-box'
        },
        '& .MuiSelect-icon': {
            color: '#39ACE7 !important',
            fill: '#39ACE7 !important'
        }
    };

    const lightAutocompleteSxProps = {
        backgroundColor: '#EFF6FF !important',
        borderRadius: '4px',
        height: '38px',
        '& .MuiInputBase-root': {
            backgroundColor: '#EFF6FF !important',
            color: '#000000 !important',
            fontSize: '14px',
            fontWeight: '500',
            height: '38px',
            paddingTop: '0 !important',
            paddingBottom: '0 !important',
            display: 'flex',
            alignItems: 'center'
        },
        '& .MuiInputBase-input': {
            color: '#000000 !important',
            backgroundColor: 'transparent !important',
            paddingTop: '8px !important',
            paddingBottom: '8px !important',
            height: 'auto !important',
            boxSizing: 'border-box',
            '&::placeholder': {
                color: '#64748b !important',
                opacity: 1
            }
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#39ACE7 !important'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#39ACE7 !important'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#39ACE7 !important'
        },
        '& .MuiAutocomplete-popupIndicator': {
            color: '#39ACE7 !important',
            '& svg': { fill: '#39ACE7 !important' }
        },
        '& .MuiAutocomplete-clearIndicator': {
            color: '#39ACE7 !important',
            '& svg': { fill: '#39ACE7 !important' }
        }
    };

    const lightMenuProps = {
        PaperProps: {
            sx: {
                backgroundColor: '#EFF6FF !important',
                color: '#000000 !important',
                border: '1px solid #cbd5e1',
                borderRadius: '4px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                '& .MuiMenuItem-root': {
                    color: '#000000 !important',
                    backgroundColor: '#EFF6FF !important',
                    fontSize: '14px',
                    '&:hover': {
                        backgroundColor: '#dbeafe !important',
                        color: '#000000 !important'
                    },
                    '&.Mui-disabled': {
                        color: '#94a3b8 !important',
                        backgroundColor: '#EFF6FF !important'
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#bfdbfe !important',
                        color: '#000000 !important',
                        fontWeight: 600
                    },
                    '&.Mui-selected:hover': {
                        backgroundColor: '#bfdbfe !important',
                        color: '#000000 !important'
                    }
                }
            }
        }
    };

    const lightAutocompleteComponentsProps = {
        paper: {
            sx: {
                backgroundColor: '#EFF6FF !important',
                color: '#000000 !important',
                border: '1px solid #cbd5e1',
                borderRadius: '4px',
                '& .MuiAutocomplete-option': {
                    backgroundColor: '#EFF6FF !important',
                    color: '#000000 !important',
                    '& .MuiTypography-root': {
                        color: '#000000 !important'
                    },
                    '&:hover, &.Mui-focused': {
                        backgroundColor: '#dbeafe !important',
                        color: '#000000 !important',
                        '& .MuiTypography-root': {
                            color: '#000000 !important'
                        }
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#bfdbfe !important',
                        color: '#000000 !important',
                        '& .MuiTypography-root': {
                            color: '#000000 !important'
                        }
                    },
                    '&.Mui-selected:hover': {
                        backgroundColor: '#bfdbfe !important',
                        color: '#000000 !important',
                        '& .MuiTypography-root': {
                            color: '#000000 !important'
                        }
                    }
                }
            }
        }
    };

    const renderAutocomplete = (
        filter: any,
        idx: number,
        list: any[],
        loading: boolean | null | undefined,
        fallbackLabel: string,
        filterName: string,
        placeholder: string = "Search Jobs"
    ) => (
        <Grid item xs={5.8}>
            <CustomAutocomplete
                options={list}
                noOptionsText={getNoOptionsText(loading, fallbackLabel)}
                value={filter.keywords}
                onClose={(e, val) => handleOnClose(e, idx, val)}
                onChange={(e, val) => handleChangeDynamicKeywords(e, idx, val, filterName)}
                sx={lightAutocompleteSxProps}
                componentsProps={lightAutocompleteComponentsProps}
                customTextFieldProps={{
                    placeholder,
                    onChange: (e) => onChangeFieldInput(e, idx, filterName),
                    onKeyDown: (e) => onChangeFieldKeyDown(e),
                    ...autocompleteTextFieldProps
                }}
                popupIcon={<ExpandMoreIcon sx={{ color: '#39ACE7 !important', fill: '#39ACE7 !important' }} />}
            />
        </Grid>
    );

    return (
        <Box className={"main-bordered-container"} sx={{ mt: 3, padding: '10px', borderRadius: '8px', backgroundColor: '#ffffff' }}>

            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} gap={{ xs: 2, sm: 5 }} mb={2} px={2}>
                <Typography variant="body2" sx={{ opacity: 0.7, color: 'textLight.main',display:'flex',gap:'4px', minWidth: 'max-content' }}>
                    <img src={info} alt="" /> This section is to configure jobs/pipelines.
                </Typography>
                <FormControl fullWidth>
                    <CustomAutocomplete
                        textFieldLabel={getLabel()}
                        options={projectData?.map((item: any) => item.Project_Name)}
                        value={prjname}
                        onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue);
                        }}
                        onChange={(event, newValue) => handleProjectChange(event, newValue)}
                        onBlur={() => {
                            handleProjectChange(null, inputValue);
                        }}
                        sx={getInputCustomCommonSx(colors, undefined, '#39ACE7')}
                        componentsProps={lightAutocompleteComponentsProps}
                        customTextFieldProps={getCommonCustomTextFieldProps(colors)}
                        popupIcon={<ExpandMoreIcon sx={{ color: '#39ACE7 !important', fill: '#39ACE7 !important' }} />}
                    />
                </FormControl>
            </Stack>

            <Stack mt={1} p={2} spacing={2}>
                <WidgetCardContainer bgColor="primary.main" sx={{ maxHeight: 400, overflowY: 'auto', backgroundColor: '#ffffff !important', border: '1px solid #e2e8f0', borderRadius: '8px', p: 2 }}>
                    <Grid item container xs={12} alignItems="center" justifyContent="space-between" mb={1}>
                        <Grid item xs={6.2} display="flex" alignItems="center" gap={2}>
                            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: 'text.primary', whiteSpace: 'nowrap' }}>
                                Select Platform
                            </Typography>
                            <Box sx={{ flexGrow: 1, width: '100%' }}>
                                <CustomDropdown
                                    options={platformList.map((platform) => ({
                                        value: platform,
                                        label: platform
                                    }))}
                                    handleChange={handleChangePlatform}
                                    value={platformName}
                                    selectComponentProps={{
                                        displayEmpty: true,
                                        sx: lightDropdownSxProps
                                    }}
                                    menuProps={lightMenuProps}
                                    boxProps={{
                                        width: '100%'
                                    }}
                                    dropdownIcon={ExpandMoreIcon}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={4} display="flex" justifyContent="flex-end">
                            <Tooltip 
                                title={platformName === 'Windows Server' ? 'Bulk Upload is unavailable for Windows Server platform' : 'Bulk Upload'} 
                                placement="top"
                                disableHoverListener={platformName !== 'Windows Server'}
                            >
                                <span>
                                    <Button
                                        variant="pepwiseSecondaryOutline2"
                                        disabled={platformName === 'Windows Server'}
                                        onClick={openBulkUploadModal}
                                        sx={{
                                            width: '36px',
                                            height: '36px',
                                            minWidth: '36px',
                                            p: 0,
                                            background: 'transparent',
                                            color: 'rgba(0, 155, 216, 1)',
                                            border: '1px solid rgba(0, 155, 216, 1)',
                                            borderRadius: '4px',
                                            '&.Mui-disabled': {
                                                backgroundColor: 'rgba(0, 155, 219, 0.3)',
                                            }
                                        }}
                                    >
                                        <BulkUploadIcon style={{ width: '20px', height: '20px' }} />
                                    </Button>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid item container xs={12}>
                        <Divider style={{ borderColor: '#e2e8f0', width: '100%', margin: '12px 0' }} />
                    </Grid>
                    <Grid item container xs={12} spacing={2} alignItems="center" mb={1.5}>
                        <Grid item xs={1.2} display="flex" alignItems="center">
                            <button
                                type="button"
                                onClick={handleClear}
                                style={{
                                    fontSize: '12px',
                                    fontWeight: 700,
                                    color: '#A9ADCB',
                                    cursor: 'pointer',
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    textTransform: 'uppercase'
                                }}
                            >
                                <span style={{ fontSize: '14px', lineHeight: 1, color: '#A9ADCB' }}>✕</span> CLEAR ALL
                            </button>
                        </Grid>
                        <Grid item xs={5} style={{ fontSize: '13px', fontWeight: '600', color: '#64748b' }}>Field</Grid>
                        <Grid item xs={5.8} style={{ fontSize: '13px', fontWeight: '600', color: '#64748b' }}>Value</Grid>
                    </Grid>
                    <Grid item container xs={12}>
                        <Grid item container xs={12} spacing={2} display="flex" alignItems="center">
                            {filterCriteria?.map((filter: any, idx: number) => (
                                <Fragment key={filter.filterType + idx}>
                                    {/* REMOVE & ADD BUTTONS ON THE FAR LEFT */}
                                    <Grid item xs={1.2} display="flex" gap={0.8} alignItems="center">
                                        <Button
                                            onClick={() => handleRemoveFilter(idx)}
                                            sx={{
                                                minWidth: '32px',
                                                width: '32px',
                                                height: '32px',
                                                p: 0,
                                                border: '1px solid #fca5a5',
                                                borderRadius: '4px',
                                                color: '#ef4444',
                                                backgroundColor: '#fff',
                                                '&:hover': { backgroundColor: '#fef2f2', borderColor: '#ef4444' }
                                            }}
                                        >
                                            <CloseIcon sx={{ fontSize: '20px' }} />
                                        </Button>

                                        <Button
                                            onClick={() => handleAddFilter(idx)}
                                            sx={{
                                                minWidth: '32px',
                                                width: '32px',
                                                height: '32px',
                                                p: 0,
                                                border: '1px solid #38bdf8',
                                                borderRadius: '4px',
                                                color: '#009BD8',
                                                backgroundColor: '#fff',
                                                '&:hover': { backgroundColor: '#f0f9ff', borderColor: '#009BD8' }
                                            }}
                                        >
                                            <AddIcon sx={{ fontSize: '20px' }} />
                                        </Button>
                                    </Grid>

                                    <Grid item xs={5}>
                                        <CustomDropdown
                                            options={filterDropdownOptions}
                                            value={filter.filterType}
                                            handleChange={(e) => handleChangeDynamicFilter(e, idx)}
                                            selectComponentProps={{ 
                                                sx: lightDropdownSxProps 
                                            }}
                                            menuProps={lightMenuProps}
                                            dropdownIcon={ExpandMoreIcon}
                                        />
                                    </Grid>

                                    {/* Scheduler Name */}
                                    {filter.filterType === "Scheduler Name" && (
                                        <Grid item xs={5.8}>
                                            <CustomDropdown
                                                options={getSchedulerOptions()}
                                                value={filter.keywords}
                                                handleChange={(e) => handleChangeDynamicKeywords(e, idx)}
                                                selectComponentProps={{ 
                                                    displayEmpty: true, 
                                                    sx: lightDropdownSxProps 
                                                }}
                                                menuProps={lightMenuProps}
                                                dropdownIcon={ExpandMoreIcon}
                                            />
                                        </Grid>
                                    )}

                                    {/* Program Name */}
                                    {filter.filterType === `${singularLabelName} Name` &&
                                        renderAutocomplete(
                                            filter,
                                            idx,
                                            jobNameList,
                                            searchJobNameInputLoading,
                                            `Search ${singularLabelName}`,
                                            `${singularLabelName} Name`,
                                            "Search Jobs"
                                    )}

                                    {/* ADB Workspace */}
                                    {filter.filterType === `${labels.adbWorkspace} Name` &&
                                        renderAutocomplete(
                                            filter,
                                            idx,
                                            adbWorkspaceNameList,
                                            searchWorkspaceInputLoading,
                                            `Search ${labels.adbWorkspace}`,
                                            `${labels.adbWorkspace} Name`,
                                            `Search ${labels.adbWorkspace} Name`
                                    )}

                                    {/* ADB Gold Table Name */}
                                    {filter.filterType === `${labels.adbGoldTable} Name` &&
                                        renderAutocomplete(
                                            filter,
                                            idx,
                                            adbGoldTableNameList,
                                            searchGoldTableInputLoading,
                                            `Search ${labels.adbGoldTable}`,
                                            `${labels.adbGoldTable} Name`,
                                            `Search ${labels.adbGoldTable} Name`
                                    )}

                                    {/* Data Asset */}
                                    {filter.filterType === `${labels.dataAsset} Name` &&
                                        renderAutocomplete(
                                            filter,
                                            idx,
                                            dataAssetNameList,
                                            searchDataAssetInputLoading,
                                            `Search ${labels.dataAsset}`,
                                            `${labels.dataAsset} Name`,
                                            `Search ${labels.dataAsset} Name`
                                    )}

                                    {/* Silver Table */}
                                    {filter.filterType === `${labels.silverTable} Name` &&
                                        renderAutocomplete(
                                            filter,
                                            idx,
                                            silverTableNameList,
                                            searchSilverTableInputLoading,
                                            `Search ${labels.silverTable}`,
                                            `${labels.silverTable} Name`,
                                            `Search ${labels.silverTable} Name`
                                    )}

                                    {/* Folder */}
                                    {filter.filterType === "Folder Name" &&
                                        renderAutocomplete(
                                            filter,
                                            idx,
                                            folderNameList,
                                            searchFolderNameInputLoading,
                                            "Search Folder",
                                            "Folder Name",
                                            "Search Folder Name"
                                    )}

                                    {/* Instance */}
                                    {filter.filterType === "Instance Name" && 
                                        renderAutocomplete(
                                            filter,
                                            idx,
                                            adfNameList,
                                            searchAdfNameInputLoading,
                                            "Search Instance",
                                            "Instance Name",
                                            "Search Instance Name"
                                    )}

                                    {/* Dataset */}
                                    {filter.filterType === "Dataset" &&
                                        renderAutocomplete(
                                            filter,
                                            idx,
                                            datasetNameList,
                                            searchDatasetInputLoading,
                                            "Search Dataset",
                                            "Dataset"
                                    )}

                                    {/* Workspace */}
                                    {filter.filterType === "Workspace" &&
                                        renderAutocomplete(
                                            filter,
                                            idx,
                                            workspaceNameList,
                                            searchWorkspaceInputLoading,
                                            "Search Workspace",
                                            "Workspace"
                                    )}

                                    {/* Capacity */}
                                    {filter.filterType === "Capacity" &&
                                        renderAutocomplete(
                                            filter,
                                            idx,
                                            capacityNameList,
                                            searchCapacityInputLoading,
                                            "Search Capacity",
                                            "Capacity"
                                    )}
                                </Fragment>
                            ))}
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} justifyContent="flex-end" mt={2}>
                        <Button
                            variant="outlined"
                            disabled={isDisabled}
                            onClick={onSubmitSearchFetchJobIds}
                            sx={{
                                minWidth: '140px',
                                height: '38px',
                                color: '#39ACE7 !important',
                                borderColor: '#39ACE7 !important',
                                borderRadius: '4px',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                '&:hover': {
                                    borderColor: '#0078b4',
                                    backgroundColor: 'rgba(57, 172, 231, 0.08)',
                                },
                                '&.Mui-disabled': {
                                    borderColor: 'rgba(57, 172, 231, 0.5) !important',
                                    color: '#39ACE7 !important',
                                    opacity: 0.7
                                }
                            }}
                        >
                            Run Query
                        </Button>
                    </Grid>
                </WidgetCardContainer>

                {!!searchScheduleBtn && (
                    <Stack>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography
                                variant="pageTitle"
                                sx={{ fontSize: '16px', fontWeight: '700', color: `${colors.table.title} !important` }}
                            >
                                {`Select ${labels.name} From Search Results`}
                            </Typography>

                            <Box display="flex" alignItems="center" gap={2}>
                            
                                {tableDataList && tableDataList.length > 0 && (
                                <Button
                                    disabled={!selectedRows.length}
                                    variant="outlined"
                                    startIcon={<PlusSymbolIcon />}
                                    className={classes.addSchBtn}
                                    onClick={addSchedulesToProject}
                                    sx={{
                                    borderRadius: '4px',
                                    '&:hover': { backgroundColor: '#009BD8', color: '#fff !important' },
                                    '&.Mui-disabled': { opacity: '0.6' },
                                    '&:hover .MuiButton-startIcon svg path': { fill: '#fff !important' }
                                    }}
                                >
                                    ADD ALL SELECTED
                                </Button>
                                )}
                            </Box>
                            
                        </Box>
                        <Box id={`sch_list_details${prjid}`}>
                            {(() => {
                                let content;
                                if (!tableLoading && tableDataList.length) {
                                    content = (
                                        <CustomizedDataGrid
                                            tableColumns={platformName == 'Power BI' ? 
                                                getPowerBiColumns({
                                                    selectedRows,
                                                    tableDataList,
                                                    selectedRowsId,
                                                    reqRows,
                                                    setSelectedRows,
                                                    setTableDataList
                                                }) : 
                                                getColumns({
                                                    platformName,
                                                    labels,
                                                    selectedRows,
                                                    tableDataList,
                                                    selectedRowsId,
                                                    reqRows,
                                                    setSelectedRows,
                                                    setTableDataList
                                                })
                                            }
                                            tableData={tableDataList}
                                            tableType="add-schedules"
                                            defaultColumnNames={platformName == 'Power BI' ? PowerBiColumnNames : defaultSelectedColumnNamesPlatformBased}
                                            page={page}
                                            pageSize={pageSize}
                                            paginationData={paginationData}
                                            listLength={tableDataList.length}
                                            onHeaderSelectAll={handleHeaderSelectAll}
                                            handlepageSizeChange={handlepageSizeChange}
                                            handlePageChange={handlePageChange}
                                            isPrevNextPagination
                                            isDateRangeFilter={false}
                                            isDisabled={false}
                                            isFetching={tableLoading}
                                            onSorting={handleSorting}
                                            currSorting={sortingInfo}
                                            filterDataOptions={filterDataSearch}
                                            onFilterCheck={(filterData: any) => handleFilter(filterData, 'add-schedules')}
                                            currFilter={filterInfoSearch}
                                            onFilterSearch={(filterData: any) => handleFilter(filterData, 'add-schedules')}
                                        />
                                );
                                } else if (!tableLoading && tableDataList.length === 0) {
                                    content = (
                                        <Typography textAlign="center" sx={{ color: `${colors.table.text} !important` }}>No result found</Typography>
                                    );
                                } else {
                                    content = <LoaderComponent />;
                                }
                                return content;
                            })()}
                        </Box>
                    </Stack>
                )}
                <Stack pt={1}>
                    {addedSchedulesList && addedSchedulesList.length > 0 && !scheduleTableLoading && (
                        <Stack pt={1}>
                            {addedSchedulesList?.length ? (
                                <Box className='grid-added-jobs' sx={{ position: 'relative' }}>
                                    <CustomizedDataGrid
                                        title={`Added ${labels.name}`}
                                        tableColumns={
                                            getAddedScheduleColumns({
                                                toggleSubRow,
                                                platformName,
                                                labels,
                                                isAllowed,
                                                setDefaultPipelineId,
                                                setDefaultTriggerName,
                                                setConfigureOpen,
                                                handleTableAction
                                            })
                                        }
                                        tableData={addedSchedulesList}
                                        tableType="added-schedules"
                                        defaultColumnNames={defaultAddedColumnNamesPlatformBased}
                                        onSorting={handleSorting}
                                        currSorting={sortingInfo}
                                        onFilterCheck={handleFilter}
                                        currFilter={filterInfo}
                                        filterDataOptions={filterData}
                                        page={pageSchedule}
                                        pageSize={pageSizeSchedule}
                                        paginationData={paginationDataSchedule}
                                        listLength={addedSchedulesList.length}
                                        handlepageSizeChange={handlepageSizeChangeSchedule}
                                        handlePageChange={handlePageChangeSchedule}
                                        isPrevNextPagination
                                        isDateRangeFilter={false}
                                        isDisabled={false}
                                        isFetching={scheduleTableLoading}
                                        onFilterSearch={handleFilter}
                                    />
                                </Box>
                            ) : (
                                <Typography textAlign="center"  sx={{ color: `${colors.table.text} !important` }}>Data will be displayed based on selected filters.</Typography>
                            )}
                        </Stack>
                    )}
                    {(dependentInfoLoading || scheduleTableLoading) &&
                        <Stack justifyContent="center" alignItems="center" height="10vh">
                            <Typography variant="pageTitle" color="dark.main">
                                Loading...
                            </Typography>
                        </Stack>
                    }
                </Stack>

                {addedSchedulesList && addedSchedulesList.length > 0 && !scheduleTableLoading && configureOpen && (
                <ConfigurePipeline
                    open={configureOpen}
                    onClose={() => { setConfigureOpen(false); setDefaultPipelineId(''); setDefaultTriggerName(''); }}
                    onReopen={() => setConfigureOpen(true)}
                    pipelines={pipelines}
                    projectId={String(prjid)}
                    defaultPipelineId={defaultPipelineId || ''}
                    defaultTriggerName={defaultTriggerName || ''}
                    onSave={async (payload) => {
                        eventEmitter?.emit?.('showSnackbar', 'Pipeline parameters saved', 'success');
                        setDefaultPipelineId('');
                        setDefaultTriggerName('');
                        setConfigureOpen(false);
                        setTimeout(() => {
                            getAddedScheduleList();
                        }, 500);
                    }}
                />
                )}
                
                <Dialog open={deleteModal.isOpen} onClose={handleEditClose} fullWidth={true} maxWidth="md">
                    <DataPipelineModal handleEditClose={handleEditClose} programData={deleteModal}
                        getToastData={getToastData}
                        passInfoToParent={passInfoToParent}
                    />
                </Dialog>
                <Dialog
                    open={bulkUploadModal}
                    onClose={() => setBulkUploadModal(false)}
                    fullWidth={true}
                    maxWidth="md"
                    PaperProps={{
                        sx: {
                            borderRadius: '4px',
                            backgroundColor: 'rgba(245, 248, 252, 1)',
                        },
                    }}
                >
                    <JobBulkUpload setBulkUploadModal={setBulkUploadModal} setSelectedRows={setSelectedRows} addSchedulesToProject={addSchedulesToProject} addProjectLoading={addProjectLoading} successMsg={successMsg} successCount={successCount} getAddedScheduleList={getAddedScheduleList} platform={platformName} projectId={String(prjid)}/>

                </Dialog>
                <Snackbar
                    open={toast && openModal.message}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    autoHideDuration={6000}
                    onClick={handleClose}
                    message={openModal.message}
                />
                
                <DialogModal
                    isOpen={openModal.isOpen}
                    handleClose={handleModalClose}
                    isShowCloseButton={!searchScheduleBtn}
                    title={addProjectLoading ? 'Confirmation' : `${labels.name} Added Successfully`}
                    titleSx={{
                        p: '20px 30px !important',
                        '& .MuiTypography-root': {
                            fontWeight: 600,
                            color: 'white',
                            fontSize: '24px',
                        },
                    }}
                    PaperProps={{
                        sx: {
                            borderRadius: '4px',
                            backgroundColor: 'rgba(245, 248, 252, 1)',
                        },
                    }}
                    dialogContentProps={{
                        sx: {
                            backgroundColor: 'rgba(245, 248, 252, 1)',
                        },
                    }}
                >
                    <DialogModalContent
                        addProjectLoading={addProjectLoading}
                        successMsg={successMsg}
                        selectedRows={selectedRows}
                        labels={labels}
                        handleAddMore={handleAddMore}
                        handleModalClose={handleModalClose}
                    />
                </DialogModal>
            </Stack>
        </Box>

    )
}